// GENERIC

// DASHBOARD
export const DropdownDashboardTagExportDomains = [
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_WORKS',
        value: 'publishing-works',
        alvqa: 'dropdown-domain-publishing-works'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_SHEETS',
        value: 'publishing-sheets',
        alvqa: 'dropdown-domain-publishing-sheets'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_PROJECTS',
        value: 'publishing-projects',
        alvqa: 'dropdown-domain-publishing-projects'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_LABEL_TRACKS',
        value: 'label-tracks',
        alvqa: 'dropdown-domain-label-tracks'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_LABEL_RELEASES',
        value: 'label-releases',
        alvqa: 'dropdown-domain-label-releases'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_LABEL_PROJECTS',
        value: 'label-projects',
        alvqa: 'dropdown-domain-label-projects'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_AZ_PERSONS',
        value: 'az-persons',
        alvqa: 'dropdown-domain-az-persons'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_AZ_GROUPS',
        value: 'az-groups',
        alvqa: 'dropdown-domain-az-groups'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_CONTRACTS_PUBLISHING',
        value: 'contracts-publishing',
        alvqa: 'dropdown-domain-contracts-publishing'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_CONTRACTS_LABEL',
        value: 'contracts-label',
        alvqa: 'dropdown-domain-contracts-label'
    },
]

// PT: Currently not in use, to be used for a new BaseRegions component
export const DropdownGenericRegionsInclude = [{
    text: 'lang_GENERIC_REGIONS_WORLD',
        value: 'WELT',
        alvqa: 'dropdown-regions-world'
    },
    {
        text: 'lang_GENERIC_REGIONS_EUR',
        value: 'EUR',
        alvqa: 'dropdown-regions-europe'
    },
    {
        text: 'lang_GENERIC_REGIONS_MEA',
        value: 'MEA',
        alvqa: 'dropdown-regions-middle-east-and-africa'
    },
]

export const DropdownDashboardCsvConversionTools = [
    {
        text: 'lang_DASHBOARD_CAPTION_CSV_CONVERSION_TOOLS_OPTION_SUISA',
        value: 'suisa',
        alvqa: 'dropdown-suisa',
        validation: ['F', 'E3', 'M2']
    },
    {
        text: 'lang_DASHBOARD_CAPTION_CSV_CONVERSION_TOOLS_OPTION_AKM',
        value: 'akm',
        alvqa: 'dropdown-akm',
        validation: ['TXT']
    },
    {
        text: 'AUME (TXT)',
        value: 'aume',
        alvqa: 'dropdown-aume',
        validation: ['TXT']
    },
    {
        text: 'lang_DASHBOARD_CAPTION_CSV_CONVERSION_TOOLS_OPTION_CSV_SANITIZER',
        value: 'csvSanitizer',
        alvqa: 'dropdown-csv-sanitizer',
        validation: ['CSV', 'TXT']
    },
    {
        text: 'lang_DASHBOARD_CAPTION_CSV_CONVERSION_TOOLS_OPTION_PARTIES_IN_COLUMNS',
        value: 'partiesInColumns',
        alvqa: 'dropdown-parties-in-columns',
        validation: ['CSV'],
        // Only visible for specific accounts. Currently calibrated for NTVM
        // (account 327) using Liberry-format source CSV. Remove this gate
        // once the converter is generic enough for other source formats.
        restrictToAccountIds: ['327', '249']
    },
]
// PT: Currently not in use, to be used for a new BaseRegions component
export const DropdownGenericRegionsExclude = [{
        text: 'lang_GENERIC_REGIONS_GAS',
        value: 'GAS',
        alvqa: 'dropdown-regions-germany-austria-switzerland'
    },
    {
        text: 'lang_GENERIC_REGIONS_EUR',
        value: 'EUR',
        alvqa: 'dropdown-regions-europe'
    },
    {
        text: 'lang_GENERIC_REGIONS_MEA',
        value: 'MEA',
        alvqa: 'dropdown-regions-middle-east-and-africa'
    },
]

export const DropdownGenericMusicLanguages = [{
        text: 'lang_GENERIC_MUSIC_LANGUAGES_ENGLISH',
        value: 'en',
        alvqa: 'dropdown-music-languages-english'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_GERMAN',
        value: 'de',
        alvqa: 'dropdown-music-languages-german'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_FRENCH',
        value: 'fr',
        alvqa: 'dropdown-music-languages-french'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_SPANISH',
        value: 'es',
        alvqa: 'dropdown-music-languages-spanish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_ITALIAN',
        value: 'it',
        alvqa: 'dropdown-music-languages-italian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_PORTUGUESE',
        value: 'pt',
        alvqa: 'dropdown-music-languages-portuguese'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_DUTCH',
        value: 'nl',
        alvqa: 'dropdown-music-languages-dutch'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_IRISH',
        value: 'ga',
        alvqa: 'dropdown-music-languages-irish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_JAPANESE',
        value: 'ja',
        alvqa: 'dropdown-music-languages-japanese'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_KOREAN',
        value: 'ko',
        alvqa: 'dropdown-music-languages-korean'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_CHINESE',
        value: 'zh',
        alvqa: 'dropdown-music-languages-chinese'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_RUSSIAN',
        value: 'ru',
        alvqa: 'dropdown-music-languages-russian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_POLISH',
        value: 'pl',
        alvqa: 'dropdown-music-languages-polish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_SWEDISH',
        value: 'sv',
        alvqa: 'dropdown-music-languages-swedish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_ROMANIAN',
        value: 'ro',
        alvqa: 'dropdown-music-languages-romanian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_NORWEGIAN',
        value: 'no',
        alvqa: 'dropdown-music-languages-norwegian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_FINNISH',
        value: 'fi',
        alvqa: 'dropdown-music-languages-finnish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_HUNGARIAN',
        value: 'hu',
        alvqa: 'dropdown-music-languages-hungarian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_DANISH',
        value: 'da',
        alvqa: 'dropdown-music-languages-danish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_VIETNAMESE',
        value: 'vi',
        alvqa: 'dropdown-music-languages-vietnamese'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_ZULU',
        value: 'zu',
        alvqa: 'dropdown-music-languages-zulu'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_XHOSA',
        value: 'xh',
        alvqa: 'dropdown-music-languages-xhosa'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_TSWANA',
        value: 'tn',
        alvqa: 'dropdown-music-languages-tswana'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_LINGALA',
        value: 'ln',
        alvqa: 'dropdown-music-languages-lingala'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_INDONESIAN',
        value: 'id',
        alvqa: 'dropdown-music-languages-indonesian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_MALAY',
        value: 'ms',
        alvqa: 'dropdown-music-languages-malay'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_GREEK',
        value: 'el',
        alvqa: 'dropdown-music-languages-greek'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_ALBANIAN',
        value: 'sq',
        alvqa: 'dropdown-music-languages-albanian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_TURKISH',
        value: 'tr',
        alvqa: 'dropdown-music-languages-turkish'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_HINDI',
        value: 'hi',
        alvqa: 'dropdown-music-languages-hindi'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_HEBREW',
        value: 'he',
        alvqa: 'dropdown-music-languages-hebrew'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_UKRAINIAN',
        value: 'uk',
        alvqa: 'dropdown-music-languages-ukrainian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_SERBIAN',
        value: 'sr',
        alvqa: 'dropdown-music-languages-serbian'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_CREOLE',
        value: 'kr',
        alvqa: 'dropdown-music-languages-creole'
    },
    {
        text: 'lang_GENERIC_MUSIC_LANGUAGES_SCOTTISH_GAELIC',
        value: 'gd',
        alvqa: 'dropdown-music-languages-scottish-gaelic'
    },
]

export const DropdownGeneralPriceCategories = [{
        text: 'lang_GENERAL_PRICE_CATEGORY_HIGHPRICE',
        value: 'highprice',
        alvqa: 'dropdown-price-category-highprice'
    },
    {
        text: 'lang_GENERAL_PRICE_CATEGORY_MIDPRICE',
        value: 'midprice',
        alvqa: 'dropdown-price-category-midprice'
    },
    {
        text: 'lang_GENERAL_PRICE_CATEGORY_BUDGET',
        value: 'budget',
        alvqa: 'dropdown-price-category-budget'
    },
]

export const DropdownGeneralPeriodTimeUnits = [{
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_MONTH',
        value: 'month',
        alvqa: 'period-selector-dropdown-period-selector-time-units-month'
    },
    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_QUARTER',
        value: 'quarter',
        alvqa: 'period-selector-dropdown-period-selector-time-units-quarter'
    },
    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_HALFYEAR',
        value: 'halfyear',
        alvqa: 'period-selector-dropdown-period-selector-time-units-halfyear'
    },
    {
        text: 'lang_GENERIC_PERIOD_FILTER_OPTION_YEAR',
        value: 'year',
        alvqa: 'period-selector-dropdown-period-selector-time-units-year'
    }
]

export const DropdownGenericCostGroupTypes = [{
        text: 'lang_GENERIC_COST_GROUP_TYPE_MANUFACTURING',
        value: 'manufacturing',
        alvqa: 'dropdown-cost-group-manufacturing'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_ADVERTISING',
        value: 'advertising',
        alvqa: 'dropdown-cost-group-advertising'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_MARKETING',
        value: 'marketing',
        alvqa: 'dropdown-cost-group-marketing'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_PROMOTION',
        value: 'promotion',
        alvqa: 'dropdown-cost-group-promotion'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_PRODUCTION',
        value: 'production',
        alvqa: 'dropdown-cost-group-production'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_OTHER',
        value: 'other',
        alvqa: 'dropdown-cost-group-other'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_LIVE',
        value: 'live',
        alvqa: 'dropdown-cost-group-live'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_ADVANCE',
        value: 'advance',
        alvqa: 'dropdown-cost-group-advance'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_LICENSES',
        value: 'licenses',
        alvqa: 'dropdown-cost-group-licenses '
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_MECHANICALS',
        value: 'mechanicals',
        alvqa: 'dropdown-cost-group-mechanicals '
    },
]

export const DropdownPublishingContractsCostGroupTypes = [{
        text: 'lang_PUBLISHING_CONTRACTS_CAPTION_COST_GROUP_PRODUCTION',
        value: 'production',
        alvqa: 'dropdown-publishing-cost-group-production'
    },
    {
        text: 'lang_PUBLISHING_CONTRACTS_CAPTION_COST_GROUP_ADMINISTRATION',
        value: 'administration',
        alvqa: 'dropdown-publishing-cost-group-administration'
    },
    {
        text: 'lang_PUBLISHING_CONTRACTS_CAPTION_COST_GROUP_LEGAL',
        value: 'legal',
        alvqa: 'dropdown-publishing-cost-group-legal'
    },
    {
        text: 'lang_PUBLISHING_CONTRACTS_CAPTION_COST_GROUP_OTHER',
        value: 'other',
        alvqa: 'dropdown-publishing-cost-group-other'
    },
]

export const DropdownGeneralPeriodTimeUnitsWithUndefined = [{
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_MONTH',
        value: 'month',
        alvqa: 'period-selector-dropdown-period-selector-time-units-month'
    },
    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_QUARTER',
        value: 'quarter',
        alvqa: 'period-selector-dropdown-period-selector-time-units-quarter'
    },
    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_HALFYEAR',
        value: 'halfyear',
        alvqa: 'period-selector-dropdown-period-selector-time-units-halfyear'
    },
    {
        text: 'lang_GENERIC_PERIOD_FILTER_OPTION_YEAR',
        value: 'year',
        alvqa: 'period-selector-dropdown-period-selector-time-units-year'
    },
    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_NOT_DEFINED',
        value: 'notDefined',
        alvqa: 'period-selector-dropdown-period-selector-time-units-not-defined'
    }
]

export const DropdownGeneralPeriodTimeUnitsWithoutMonth = [

    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_QUARTER',
        value: 'quarter',
        alvqa: 'period-selector-dropdown-period-selector-time-units-quarter'
    },
    {
        text: 'lang_GENERAL_PERIOD_FILTER_OPTION_HALFYEAR',
        value: 'halfyear',
        alvqa: 'period-selector-dropdown-period-selector-time-units-halfyear'
    },
    {
        text: 'lang_GENERIC_PERIOD_FILTER_OPTION_YEAR',
        value: 'year',
        alvqa: 'period-selector-dropdown-period-selector-time-units-year'
    }
]

export const DropdownGenericYesNo = [
    {
        text: 'lang_GENERAL_YES',
        value: 'yes',
        alvqa: 'dropdown-generic-yes'
    },
    {
        text: 'lang_GENERAL_NO',
        value: 'no',
        alvqa: 'dropdown-generic-no'
    },
]
export const DropdownGenericYesNoOpwSpw = [
    {
        text: 'lang_PUBLISHING_WORKS_CAPTION_NO_FOR_OPW',
        value: 'no',
        alvqa: 'dropdown-generic-no-for-opw'
    },
    {
        text: 'lang_PUBLISHING_WORKS_CAPTION_YES_FOR_SPW',
        value: 'yes',
        alvqa: 'dropdown-generic-yes-for-spw'
    },
]

export const DropdownGenericInterestedPartyRoles = [{
        text: 'C',
        value: 'C',
        alvqa: 'dropdown-genereic-interesed-party-roles-c'
    },
    {
        text: 'A',
        value: 'A',
        alvqa: 'dropdown-genereic-interesed-party-roles-a'
    },
    {
        text: 'AR',
        value: 'AR',
        alvqa: 'dropdown-genereic-interesed-party-roles-ar'
    },
    {
        text: 'SR',
        value: 'SR',
        alvqa: 'dropdown-genereic-interesed-party-roles-sr'
    },
    {
        text: 'CA',
        value: 'CA',
        alvqa: 'dropdown-genereic-interesed-party-roles-ca'
    },
    {
        text: 'TS',
        value: 'TS',
        alvqa: 'dropdown-genereic-interesed-party-roles-ts'
    },
    {
        text: 'ST',
        value: 'ST',
        alvqa: 'dropdown-genereic-interesed-party-roles-st'
    },
    {
        text: 'TNA',
        value: 'TNA',
        alvqa: 'dropdown-genereic-interesed-party-roles-tna'
    },
    {
        text: 'TNE',
        value: 'TNE',
        alvqa: 'dropdown-genereic-interesed-party-roles-tne'
    },
    {
        text: 'E',
        value: 'E',
        alvqa: 'dropdown-genereic-interesed-party-roles-e'
    },
    {
        text: 'SE',
        value: 'SE',
        alvqa: 'dropdown-genereic-interesed-party-roles-se'
    },
    {
        text: 'SA',
        value: 'SA',
        alvqa: 'dropdown-genereic-interesed-party-roles-sa'
    },
]

// ARTISTS Roles
export const DropdownGeneralArtistRoles = [{
        text: 'Performer',
        value: 'performer',
        alvqa: 'dropdown-artist-roles-performer'
    },
    {
        text: 'Narrator',
        value: 'narrator',
        alvqa: 'dropdown-artist-roles-narrator'
    },
    {
        text: 'Featuring',
        value: 'featuring',
        alvqa: 'dropdown-artist-roles-featuring'
    },
    {
        text: 'with',
        value: 'with',
        alvqa: 'dropdown-artist-roles-with'
    },
    {
        text: 'Presents',
        value: 'presents',
        alvqa: 'dropdown-artist-roles-presents'
    },
    {
        text: 'Versus',
        value: 'versus',
        alvqa: 'dropdown-artist-roles-versus'
    },
    {
        text: 'Meets',
        value: 'meets',
        alvqa: 'dropdown-artist-roles-meets'
    },
    {
        text: 'Producer',
        value: 'producer',
        alvqa: 'dropdown-artist-roles-producer'
    },
    {
        text: 'Remixer',
        value: 'remixer',
        alvqa: 'dropdown-artist-roles-remixer'
    },
    {
        text: 'Singer',
        value: 'singer',
        alvqa: 'dropdown-artist-roles-singer'
    },
    {
        text: 'Musician',
        value: 'musician',
        alvqa: 'dropdown-artist-roles-musician'
    },
    // {
    //     text: 'Alto Singer',
    //     value: 'altoSinger',
    //     alvqa: 'dropdown-artist-roles-alto-singer'
    // },
    // {
    //     text: 'Arranger',
    //     value: 'arranger',
    //     alvqa: 'dropdown-artist-roles-arranger'
    // },
    // {
    //     text: 'Baritone Singer',
    //     value: 'baritoneSinger',
    //     alvqa: 'dropdown-artist-roles-baritone-singer'
    // },
    // {
    //     text: 'Bass Singer',
    //     value: 'bassSinger',
    //     alvqa: 'dropdown-artist-roles-bass-singer'
    // },
    // {
    //     text: 'Bass Guitar',
    //     value: 'bassGuitar',
    //     alvqa: 'dropdown-artist-roles-bass-guitar'
    // },
    // {
    //     text: 'Bassoon',
    //     value: 'bassoon',
    //     alvqa: 'dropdown-artist-roles-bassoon'
    // },
    // {
    //     text: 'Cello',
    //     value: 'cello',
    //     alvqa: 'dropdown-artist-roles-cello'
    // },
    // {
    //     text: 'Chorus',
    //     value: 'chorus',
    //     alvqa: 'dropdown-artist-roles-chorus'
    // },
    // {
    //     text: 'Clarinet',
    //     value: 'clarinet',
    //     alvqa: 'dropdown-artist-roles-clarinet'
    // },
    // {
    //     text: 'Conductor',
    //     value: 'conductor',
    //     alvqa: 'dropdown-artist-roles-conductor'
    // },
    // {
    //     text: 'Contrabass',
    //     value: 'contrabass',
    //     alvqa: 'dropdown-artist-roles-contrabass'
    // },
    // {
    //     text: 'DJ',
    //     value: 'dj',
    //     alvqa: 'dropdown-artist-roles-dj'
    // },
    // {
    //     text: 'Drums',
    //     value: 'drums',
    //     alvqa: 'dropdown-artist-roles-drums'
    // },
    // {
    //     text: 'Engineer',
    //     value: 'engineer',
    //     alvqa: 'dropdown-artist-roles-engineer'
    // },
    // {
    //     text: 'Ensemble',
    //     value: 'ensemble',
    //     alvqa: 'dropdown-artist-roles-ensemble'
    // },
    // {
    //     text: 'Flute',
    //     value: 'flute',
    //     alvqa: 'dropdown-artist-roles-flute'
    // },
    // {
    //     text: 'French Horn',
    //     value: 'frenchHorn',
    //     alvqa: 'dropdown-artist-roles-french-horn'
    // },
    // {
    //     text: 'Guitar',
    //     value: 'guitar',
    //     alvqa: 'dropdown-artist-roles-guitar'
    // },
    // {
    //     text: 'Harmonica',
    //     value: 'harmonica',
    //     alvqa: 'dropdown-artist-roles-harmonica'
    // },
    // {
    //     text: 'Harp',
    //     value: 'harp',
    //     alvqa: 'dropdown-artist-roles-harp'
    // },
    // {
    //     text: 'Harpsichord',
    //     value: 'harpsichord',
    //     alvqa: 'dropdown-artist-roles-harpsichord'
    // },
    // {
    //     text: 'Keyboards',
    //     value: 'keyboards',
    //     alvqa: 'dropdown-artist-roles-keyboards'
    // },
    // {
    //     text: 'Mezzo Soprano Singer',
    //     value: 'mezzoSopranoSinger',
    //     alvqa: 'dropdown-artist-roles-mezzo-soprano-singer'
    // },
    // {
    //     text: 'Oboe',
    //     value: 'oboe',
    //     alvqa: 'dropdown-artist-roles-oboe'
    // },
    // {
    //     text: 'Orchestra',
    //     value: 'orchestra',
    //     alvqa: 'dropdown-artist-roles-orchestra'
    // },
    // {
    //     text: 'Organ',
    //     value: 'organ',
    //     alvqa: 'dropdown-artist-roles-organ'
    // },
    // {
    //     text: 'Percussion',
    //     value: 'percussion',
    //     alvqa: 'dropdown-artist-roles-percussion'
    // },
    // {
    //     text: 'Piano',
    //     value: 'piano',
    //     alvqa: 'dropdown-artist-roles-piano'
    // },
    // {
    //     text: 'Saxophone',
    //     value: 'saxophone',
    //     alvqa: 'dropdown-artist-roles-saxophone'
    // },
    // {
    //     text: 'Soloist',
    //     value: 'soloist',
    //     alvqa: 'dropdown-artist-roles-soloist'
    // },
    // {
    //     text: 'Soprano Singer',
    //     value: 'sopranoSinger',
    //     alvqa: 'dropdown-artist-roles-soprano-singer'
    // },
    // {
    //     text: 'String Bass',
    //     value: 'stringBass',
    //     alvqa: 'dropdown-artist-roles-string-bass'
    // },
    // {
    //     text: 'Synthesizer',
    //     value: 'synthesizer',
    //     alvqa: 'dropdown-artist-roles-synthesizer'
    // },
    // {
    //     text: 'Tenor Singer',
    //     value: 'tenorSinger',
    //     alvqa: 'dropdown-artist-roles-tenor-singer'
    // },
    // {
    //     text: 'Trombone',
    //     value: 'trombone',
    //     alvqa: 'dropdown-artist-roles-trombone'
    // },
    // {
    //     text: 'Trumpet',
    //     value: 'trumpet',
    //     alvqa: 'dropdown-artist-roles-trumpet'
    // },
    // {
    //     text: 'Tuba',
    //     value: 'tuba',
    //     alvqa: 'dropdown-artist-roles-tuba'
    // },
    // {
    //     text: 'Viola',
    //     value: 'viola',
    //     alvqa: 'dropdown-artist-roles-viola'
    // },
    // {
    //     text: 'Violin',
    //     value: 'violin',
    //     alvqa: 'dropdown-artist-roles-violin'
    // },
    // {
    //     text: 'Vocals',
    //     value: 'vocals',
    //     alvqa: 'dropdown-artist-roles-vocals'
    // }
]

// PUBLISHING
export const DropdownPublishingWorksAlternativeTitleTypes = [{
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_ALTERNATIVE_TITLE",
        value: "ALVZ",
        alvqa: "publishing-works-alternative-title-dropdown-type-alvz"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_TITLE_OF_COMPLETE_WORK",
        value: "AUS",
        alvqa: "publishing-works-alternative-title-dropdown-type-aus"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_CONTENT",
        value: "INH",
        alvqa: "publishing-works-alternative-title-dropdown-type-inh"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_MIX",
        value: "MIX",
        alvqa: "publishing-works-alternative-title-dropdown-type-mix"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_ORIGINAL_TITLE",
        value: "FREI",
        alvqa: "publishing-works-alternative-title-dropdown-type-frei"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_PRODUCTION_TITLE",
        value: "PROD",
        alvqa: "publishing-works-alternative-title-dropdown-type-prod"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_OTHER_TITLE",
        value: "SONST",
        alvqa: "publishing-works-alternative-title-dropdown-type-sonst"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_ADAPTED_TITLE",
        value: "TSTIT",
        alvqa: "publishing-works-alternative-title-dropdown-type-tstit"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_TITLE_SOUND_CARRIER",
        value: "TTTIT",
        alvqa: "publishing-works-alternative-title-dropdown-type-tttit"
    },
    {
        text: "lang_PUBLISHING_WORKS_ALTERNATIVE_TITLES_TYPE_KATAKANA",
        value: "KATA",
        alvqa: "publishing-works-alternative-title-dropdown-type-kata"
    }
]

export const DropdownPublishingWorksOtherPersonsTypes = [{
        text: "lang_PUBLISHING_WORKS_OTHER_PERSONS_TYPE_PUBLISHER_WO_PARTICIPATION",
        value: "ABV",
        alvqa: "publishing-works-other-persons-dropdown-type-abv"
    },
    {
        text: "lang_PUBLISHING_WORKS_OTHER_PERSONS_TYPE_PERFORMER",
        value: "IN",
        alvqa: "publishing-works-other-persons-dropdown-type-in"
    },
]

export const DropdownPublishingWorksExportWorksTypes = [{
        text: "lang_PUBLISHING_WORKS_ACTION_EXPORT_WORKS_TYPES_ONLY_OPW",
        value: "exportOpwTypes",
        alvqa: "publishing-works-export-works-types-opw"
    },
    {
        text: "lang_PUBLISHING_WORKS_ACTION_EXPORT_WORKS_TYPES_ONLY_SPW",
        value: "exportSpwTypes",
        alvqa: "publishing-works-export-works-types-spw"
    },
    {
        text: "lang_PUBLISHING_WORKS_ACTION_EXPORT_WORKS_TYPES_ONLY_UPW",
        value: "exportUpwTypes",
        alvqa: "publishing-works-export-works-types-upw"
    },
    // {
    //     text: "lang_PUBLISHING_WORKS_ACTION_EXPORT_WORKS_TYPES_ALL", 
    //     value: "exportAllTypes",
    //     alvqa: "publishing-works-export-works-types-all"
    // },
]

export const DropdownPublishingWorksRegistrationShareTypes = [{
        text: "OWN%",
        value: "own",
        alvqa: 'publishing-works-registration-share-type-own',
    },
    {
        text: "INTL%",
        value: "intl",
        alvqa: 'publishing-works-registration-share-type-intl',
    },
]

export const DropdownPublishingWorksStatus = [{
        text: 'lang_PUBLISHING_WORKS_CAPTION_REGISTERED',
        value: 'registered',
        alvqa: 'publishing-works-status-registered'
    },
    {
        text: 'lang_PUBLISHING_WORKS_CAPTION_GHOST',
        value: 'ghost',
        alvqa: 'publishing-works-status-ghost'
    },
    {
        text: 'lang_PUBLISHING_WORKS_STATUS_IN_REGISTRATION_PROCESS',
        value: 'inRegistrationProcess',
        alvqa: 'publishing-works-status-in-registration-process'
    },
    {
        text: 'lang_PUBLISHING_WORKS_STATUS_FILTER_OPTION_GEMA_STATUS_2',
        value: 'gemaStatus=2',
        alvqa: 'publishing-works-status-gema-status-2'
    },
    {
        text: 'lang_PUBLISHING_WORKS_CAPTION_TO_BE_REGISTERED',
        value: 'toBeRegistered',
        alvqa: 'publishing-works-status-to-be-registered'
    },
    {
        text: 'lang_PUBLISHING_WORKS_CAPTION_TO_BE_UPDATED',
        value: 'update',
        alvqa: 'publishing-works-status-to-be-updated'
    },
]

export const DropdownPublishingWorksTypes = [{
        text: 'lang_PUBLISHING_WORKS_DROPDOWN_TYPE_OPW',
        value: 'opw',
        alvqa: "publishing-works-type-opw"
    },
    {
        text: 'lang_PUBLISHING_WORKS_DROPDOWN_TYPE_SPW',
        value: 'spw',
        alvqa: 'publishing-works-type-spw'
    },
    {
        text: 'lang_PUBLISHING_WORKS_DROPDOWN_TYPE_UPW',
        value: 'upw',
        alvqa: 'publishing-works-type-upw'
    }
]

export const DropdownDistributionSearchFunctions = [{
        text: 'lang_GENERIC_CAPTION_WORK_REGISTRATION',
        value: 'work-registration',
        alvqa: "publishing-works-distribution-search-function-work-registration"
    },
    {
        text: 'lang_GENERIC_CAPTION_SOUNDFILE',
        value: 'gema-soundfile',
        alvqa: 'publishing-works-distribution-search-function-soundfile'
    },
]

export const DropdownDistributionSearchStatus = [{
        text: 'lang_GENERIC_CAPTION_SUBMITTED',
        value: 'submitted',
        alvqa: "publishing-works-distribution-search-status-submitted"
    },
    {
        text: 'lang_GENERIC_CAPTION_REGISTERED',
        value: 'registered',
        alvqa: 'publishing-works-distribution-search-status-registered'
    },
    {
        text: 'lang_GENERIC_CAPTION_REJECTED',
        value: 'rejected',
        alvqa: 'publishing-works-distribution-search-status-rejected'
    },
    {
        text: 'lang_GENERIC_CAPTION_SUCCESS',
        value: 'success',
        alvqa: 'publishing-works-distribution-search-status-success'
    },
    {
        text: 'lang_GENERIC_CAPTION_ERROR',
        value: 'error',
        alvqa: 'publishing-works-distribution-search-status-successful'
    },
]

export const DropdownPublishingWorksOldMrSplit = [{
        text: 'lang_PUBLISHING_WORKS_DROPDOWN_OPTION_CURRENT_DISTRIBUTION',
        value: 'currentDistribution',
        alvqa: "publishing-works-edit-form-dropdown-old-mr-split-current-distribution"
    },
    {
        text: 'lang_PUBLISHING_WORKS_DROPDOWN_OPTION_HALF_MR',
        value: 'halfMR',
        alvqa: 'publishing-works-edit-form-dropdown-old-mr-split-half-mr'
    }
]

export const DropdownPublishingSheetsWorkAvType = [{
        text: "lang_PUBLISHING_SHEETS_CAPTION_COMMISSIONED_COMPOSITION",
        value: 1,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-type-composition'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_LIBRARY",
        value: 4,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-type-library-work'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_EXISTING_WORK",
        value: 2,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-type-existing-work'
    },
    {
        divider: true
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_COMMISSIONED_WORK",
        value: 3,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-type-commissioned-work',
        disabled: 1
    }

]

export const DropdownPublishingSheetsWorkSetlistType = [{
        text: 'F',
        value: 'F',
        alvqa: 'publishing-sheets-edit-form-dropdown-setlist-type-f'
    },
    {
        text: 'P',
        value: 'P',
        alvqa: 'publishing-sheets-edit-form-dropdown-setlist-type-p'
    },
    {
        text: 'F/P',
        value: 'FP',
        alvqa: 'publishing-sheets-edit-form-dropdown-setlist-type-f-p'
    }
]

export const DropdownPublishingSheetsWorkCharacteristicType = [
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_CREDITS",
        value: 4,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-credits'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_OPENING_CREDITS",
        value: 1,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-opening-credits'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_ILLUSTRATION_MUSIC",
        value: 3,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-illustration-music'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_LOGO",
        value: 8,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-logo'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_JINGLE",
        value: 6,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-jingle'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_VISUAL_MUSIC",
        value: 5,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-visual-music'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_VIDEOCLIP",
        value: 7,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-videoclip'
    },
    {
        divider: true
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_THEME_SONG",
        value: 2,
        alvqa: 'publishing-sheets-edit-form-dropdown-av-characteristic-theme-song',
        disabled: 1
    }
]

export const DropdownPublishingSheetsInternetOptions = [{
        text: "lang_PUBLISHING_SHEETS_CAPTION_INITAL_USE_INTERNET_PRODUCTION",
        value: 1,
        alvqa: 'publishing-sheets-edit-form-dropdown-internet-initial-use-internetproduction'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_SECOND_USE_TV_PRODUCTION",
        value: 2,
        alvqa: 'publishing-sheets-edit-form-dropdown-internet-second-use-internetproduction'
    },
    {
        text: "lang_PUBLISHING_SHEETS_CAPTION_ECONOMIC_FILM",
        value: 3,
        alvqa: 'publishing-sheets-edit-form-dropdown-internet-economic-film'
    }
]

export const DropdownPublishingSheetsTypeOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_FILMTV",
        value: "film/tv",
        alvqa: 'publishing-sheets-edit-form-dropdown-type-filmtv'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_TYPE_SETLIST",
        value: "setlist",
        alvqa: 'publishing-sheets-edit-form-dropdown-type-setlist'
    },
]

export const DropdownPublishingSheetsAvTypeOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AVTYPE_FILM",
        value: "FILM",
        alvqa: "publishing-sheets-edit-form-dropdown-av-type-film"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AVTYPE_EPISODE",
        value: "EPISODE",
        alvqa: "publishing-sheets-edit-form-dropdown-av-type-episode"
    },
    // {
    //     text: "lang_PUBLISHING_SHEETS_DROPDOWN_AVTYPE_IMAGEFILM",
    //     value: "imagefilm",
    //     alvqa: "publishing-sheets-edit-form-dropdown-av-type-imagefilm"
    // },
    // {
    //     text: "lang_PUBLISHING_SHEETS_DROPDOWN_AVTYPE_COMMERCIAL",
    //     value: "commercial",
    //     alvqa: "publishing-sheets-edit-form-dropdown-av-type-commercial"
    // }
]

export const DropdownPublishingSheetsAvFirstExploitationOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_FIRST_EXPLOITATION_CINEMA",
        value: "CINEMA",
        alvqa: "publishing-sheets-edit-form-dropdown-av-first-exploitation-cinema"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_FIRST_EXPLOITATION_INTERNET",
        value: "INTERNET",
        alvqa: "publishing-sheets-edit-form-dropdown-av-first-exploitation-internet"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_FIRST_EXPLOITATION_TELEVISION",
        value: "TELEVISION",
        alvqa: "publishing-sheets-edit-form-dropdown-av-first-exploitation-television"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_FIRST_EXPLOITATION_COMPANY",
        value: "COMPANY",
        alvqa: "publishing-sheets-edit-form-dropdown-av-first-exploitation-company"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_FIRST_EXPLOITATION_MULTIMEDIA",
        value: "MULTIMEDIA",
        alvqa: "publishing-sheets-edit-form-dropdown-av-first-exploitation-multimedia"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_FIRST_EXPLOITATION_COMMERCIAL",
        value: "COMMERCIAL",
        alvqa: "publishing-sheets-edit-form-dropdown-av-first-exploitation-commercial"
    }
]

export const DropdownPublishingSheetsAvMessageTypeOptions = [{
    text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_MESSAGE_TYPE_NEW",
    value: "NEW",
    alvqa: "publishing-sheets-edit-form-dropdown-av-message-type-new"
},
{
    text: "lang_PUBLISHING_SHEETS_DROPDOWN_AV_MESSAGE_TYPE_CORRECTED",
    value: "CORRECTED",
    alvqa: "publishing-sheets-edit-form-dropdown-av-message-type-corrected"
}
]

export const DropdownPublishingSheetsCommissioningChannelOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_ARD",
        value: "ARD",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-ard"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_ZDF",
        value: "ZDF",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-zdf"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_RTL",
        value: "RTL",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-rtl"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_P7S1",
        value: "P7S1",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-p7s1"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_RTL2",
        value: "RTL2",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-rtl2"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_DISCO",
        value: "DISCO",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-discovery"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_DW",
        value: "DW",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-deutsche-welle"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_SKY",
        value: "SKY",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-channel-sky"
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_COMMISSIONING_CHANNEL_FOREIGN",
        value: "FOREIGN",
        alvqa: "publishing-sheets-edit-form-dropdown-commissioning-foreign"
    }
]

export const DropdownPublishingSheetsSynchronizationRightsOptions = [
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SYNCHRONIZATION_RIGHTS_MEMBER",
        value: "MEMBER",
        alvqa: 'publishing-sheets-edit-form-dropdown-synchronization-rights-member' 
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SYNCHRONIZATION_RIGHTS_GEMA",
        value: "GEMA",
        alvqa: 'publishing-sheets-edit-form-dropdown-synchronization-rights-gema' 
    }
]

export const DropdownPublishingSheetsEventTypeOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_CARNIVAL",
        value: "carnival",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-carnival'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_CELEBRATION",
        value: "celebration",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-celebration'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_STREET_PARADE",
        value: "streetParade",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-street-parade'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_FESTIVAL",
        value: "festival",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-festival'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_BACKGROUND_MUSIC",
        value: "backgroundMusic",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-background-music'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_CABARET",
        value: "cabaret",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-cabaret'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_STREET_CLASSICAL_CONCERT",
        value: "classicalConcert",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-classical-concert'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_CONCERT",
        value: "concert",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-concert'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_OPENAIR_CONCERT",
        value: "openAirConcert",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-openair-concert'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_PARTY_CELEBRATION",
        value: "party/celebration",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-party-celebration'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_STREET_OTHER",
        value: "other",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-other'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_DANCE_BALL",
        value: "dance/ball",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-dance-ball'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_EVENT_TYPE_STAGE_MUSIC",
        value: "stageMusic",
        alvqa: 'publishing-sheets-edit-form-dropdown-event-type-stage-music'
    },
]

export const DropdownPublishingSheetsSetTypeOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SET_TYPE_MAIN_ACT",
        value: "mainAct",
        alvqa: 'publishing-sheets-edit-form-dropdown-set-type-main-act'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SET_TYPE_OPENING_ACT",
        value: "openingAct",
        alvqa: 'publishing-sheets-edit-form-dropdown-set-type-opening-act'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SET_TYPE_SOLE_BAND",
        value: "soleBand",
        alvqa: 'publishing-sheets-edit-form-dropdown-set-type-sole-band'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SET_TYPE_MULTIPLE_BANDS",
        value: "multipleBands",
        alvqa: 'publishing-sheets-edit-form-dropdown-set-type-multiple-bands'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SET_TYPE_DJ_LIVE",
        value: "djLive",
        alvqa: 'publishing-sheets-edit-form-dropdown-set-type-dj-live'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_SET_TYPE_STAGE_PERFORMANCE",
        value: "stagePerformance",
        alvqa: 'publishing-sheets-edit-form-dropdown-set-type-stage-performance'
    },
]

export const DropdownPublishingSheetsVenueTypeOptions = [{
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_BAR",
        value: "bar",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-bar'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_BEER_GARDEN",
        value: "beerGarden",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-beer-garden'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_CAFE",
        value: "cafe",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-cafe'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_CLUB",
        value: "club",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-club'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_RETAIL",
        value: "retail",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-retail'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_OPEN_SPACE",
        value: "openSpace",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-open-space'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_OPEN_AIR_STAGE",
        value: "openAirStage",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-open-air-stage'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_RESTAURANT",
        value: "restaurant",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-restaurant'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_HOTEL",
        value: "hotel",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-hotel'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_CHURCH",
        value: "church",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-church'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_CONCERT_HALL",
        value: "concertHall",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-concert-hall'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_CULTURAL_INSTITUTION",
        value: "culturalInstitution",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-cultural-institution'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_MULTIPURPOSE_HALL",
        value: "multipurposeHall",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-multipurpose-hall'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_NIGHTCLUB",
        value: "nightClub",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-nightclub'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_OPENAIR",
        value: "openAir",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-openair'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_SCHOOL",
        value: "school",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-school'
    },

    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_SOCIAL_FACILITY",
        value: "socialFacility",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-social-facility'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_THEATRE",
        value: "theatre",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-theatre'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_TENT",
        value: "tent",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-tent'
    },
    {
        text: "lang_PUBLISHING_SHEETS_DROPDOWN_VENUE_TYPE_OTHER",
        value: "other",
        alvqa: 'publishing-sheets-edit-form-dropdown-venue-type-other'
    },
]

// LABEL --------------------------------------------------------------------

export const DropdownGenericLabelSalesTypes = [{
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_NOSTATEMENT',
        value: 18,
        alvqa: 'dropdown-sales-type-nostatement'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_RETAIL',
        value: 1,
        alvqa: 'dropdown-sales-type-retail'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_DOWNLOAD',
        value: 2,
        alvqa: 'dropdown-sales-type-download'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_STREAM',
        value: 17,
        alvqa: 'dropdown-sales-type-stream'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE',
        value: 15,
        alvqa: 'dropdown-sales-type-license'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_DIRECT_SALES',
        value: 16,
        alvqa: 'dropdown-sales-type-direct-sales'
    },
]

export const DropdownLabelReleasesMediaTypes = [{ //
        "value": 62,
        "text": "Blu-Ray Disc",
        "disabled": "0"
    },
    { //
        "value": 97,
        "text": "Bücher",
        "disabled": "0"
    },
    { //
        "value": 48,
        "text": "CD + Bonus Maxi Single CD",
        "disabled": "0"
    },
    { //
        "value": 35,
        "text": "CD + Buch",
        "disabled": "0"
    },
    { //
        "value": 39,
        "text": "CD + DVD Video",
        "disabled": "0"
    },
    { //
        "value": 69,
        "text": "CD + Enhanced CD",
        "disabled": "0"
    },
    {
        "value": 109,
        "text": "lang_LABEL_RELEASES_MEDIA_TYPE_DROPDOWN_DIGITAL_RELEASE",
        "disabled": "1"
    },
    {
        "value": 110,
        "text": "lang_LABEL_RELEASES_MEDIA_TYPE_DROPDOWN_DIGITAL_EP",
        "disabled": "1"
    },
    {
        "value": 111,
        "text": "lang_LABEL_RELEASES_MEDIA_TYPE_DROPDOWN_DIGITAL_SINGLE",
        "disabled": "1"
    },
    { //
        "value": 105,
        "text": "Digital Video Album",
        "disabled": "0"
    },
    { //
        "value": 104,
        "text": "Digital Video Single/Maxi",
        "disabled": "0"
    },
    { //
        "value": 106,
        "text": "Digital Video Track",
        "disabled": "0"
    },
    { //
        "value": 72,
        "text": "DVD + Buch",
        "disabled": "0"
    },
    { //
        "value": 45,
        "text": "DVD Plus",
        "disabled": "0"
    },
    { //
        "value": 41,
        "text": "DVD Video Maxi",
        "disabled": "0"
    },
    { //
        "value": 43,
        "text": "DVD-Audio Album",
        "disabled": "0"
    },
    { //
        "value": 27,
        "text": "DVD-Video Album",
        "disabled": "0"
    },
    { //
        "value": 2,
        "text": "EP (analog)",
        "disabled": "0"
    },
    { //
        "value": 4,
        "text": "LP (analog)",
        "disabled": "0"
    },
    { //
        "value": 19,
        "text": "LP + Bonus-CD",
        "disabled": "0"
    },
    { //
        "value": 7,
        "text": "Maxi Single CD",
        "disabled": "0"
    },
    { //
        "value": 98,
        "text": "Noten",
        "disabled": "0"
    },
    {
        "value": 108,
        "text": "lang_LABEL_RELEASES_MEDIA_TYPE_DROPDOWN_RETAIL_RELEASE",
        "disabled": "1"
    },
    {
        "value": 107,
        "text": "lang_LABEL_RELEASES_MEDIA_TYPE_DROPDOWN_RETAIL_AND_DIGITAL_RELEASE",
        "disabled": "1"
    },
    { //
        "value": 1,
        "text": "Single (analog)",
        "disabled": "0"
    },
    {
        "value": 99,
        "text": "lang_LABEL_RELEASES_MEDIA_TYPE_DROPDOWN_OTHER_SUPPLIES",
        "disabled": "1"
    }
]

export const DropdownLabelStatisticsPlatforms = [{
        text: 'lang_LABEL_STATISTICS_PLATFORMS_AMAZON_MUSIC', 
        value: 'Amazon Music',
        alvqa: 'list-dropdown-platform-amazon-music'
    },    
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_APPLE_MUSIC', 
        value: 'Apple Music',
        alvqa: 'list-dropdown-platform-apple-music'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_DEEZER', 
        value: 'Deezer',
        alvqa: 'list-dropdown-platform-deezer'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_FACEBOOK', 
        value: 'Facebook',
        alvqa: 'list-dropdown-platform-facebook'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_NAPSTER', 
        value: 'Napster',
        alvqa: 'list-dropdown-platform-napster'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_PANDORA', 
        value: 'Pandora',
        alvqa: 'list-dropdown-platform-pandora'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_SPOTIFY', 
        value: 'Spotify',
        alvqa:'list-dropdown-platform-spotify'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_TIDAL', 
        value: 'Tidal',
        alvqa: 'list-dropdown-platform-tidal'
    },
    {
        text: 'lang_LABEL_STATISTICS_PLATFORMS_YOUTUBE', 
        value: 'YouTube',
        alvqa: 'list-dropdown-platform-youtube'
    }
]

export const DropdownLabelStatisticsSalesTypes = [{
        text: 'lang_LABEL_STATISTICS_SALES_TYPE_STREAMING_TRACKS', 
        value: 'TS',
        alvqa: 'list-dropdown-column-streaming-tracks'
    }, 
    {
        text: 'lang_LABEL_STATISTICS_SALES_TYPE_DOWNLOAD_TRACKS', 
        value: 'TD', 
        alvqa: 'list-dropdown-column-download-tracks'
    },
    {
        text: 'lang_LABEL_STATISTICS_SALES_TYPE_DOWNLOAD_BUNDLE', 
        value: 'AD',
        alvqa: 'list-dropdown-column-download-bundle'
    },
    {
        text: 'lang_LABEL_STATISTICS_CAPTION_RETAIL', 
        value: 'RT',
        alvqa: 'list-dropdown-column-retail'
    },
    {
        text: 'lang_LABEL_STATISTICS_SALES_TYPE_LICENSING', 
        value: 'L',
        alvqa: 'list-dropdown-column-licensing'
    },
    // {
    //     text: 'lang_LABEL_STATISTICS_SALES_TYPE_RETAIL_CD', 
    //     value: 'RC',
    //     alvqa: 'list-dropdown-column-retail-cd'
    // },
    // {
    //     text: 'lang_LABEL_STATISTICS_SALES_TYPE_RETAIL_VINYL', 
    //     value: 'RV',
    //     alvqa: 'list-dropdown-column-retail-vinyl'
    // }
]

export const DropdownLabelStatisticsLeftChart = [
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_COUNTRIES', 
        value: 'byCountries',
        alvqa: 'list-dropdown-left-chart-countries'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_DISTRIBUTORS', 
        value: 'byDistributors',
        alvqa: 'list-dropdown-left-chart-distributors'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_PLATFORMS', 
        value: 'byPlatforms',
        alvqa: 'list-dropdown-left-chart-platforms'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_SALES_TYPES', 
        value: 'bySalesType',
        alvqa: 'list-dropdown-left-chart-sales-type'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_MONTHS',
        value: 'byMonths',
        alvqa: 'list-dropdown-left-chart-by-months'
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_MONTHS_AND_PREVIOUS_YEAR',
        value: 'byMonthsAndPreviousYear',
        alvqa: 'list-dropdown-left-chart-by-months-and-previous-year'
    }
]

export const DropdownLabelStatisticsRightChart = [
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_COUNTRIES', 
        value: 'byCountries',
        alvqa: 'list-dropdown-left-chart-countries'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_DISTRIBUTORS', 
        value: 'byDistributors',
        alvqa: 'list-dropdown-left-chart-distributors'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_PLATFORMS', 
        value: 'byPlatforms',
        alvqa: 'list-dropdown-left-chart-platforms'  
    },
    {
        text: 'lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_SALES_TYPES', 
        value: 'bySalesType',
        alvqa: 'list-dropdown-left-chart-sales-type'  
    }
]

export const DropdownLabelStatisticsDataTable = [
    {
        text: 'lang_LABEL_STATISTICS_DATATABLE_DROPDOWN_TOP_100_ARTISTS', 
        value: 'top100Artists',
        alvqa: 'list-dropdown-data-table-top-100-artists'  
    },
    {
        text: 'lang_LABEL_STATISTICS_DATATABLE_DROPDOWN_TOP_100_COUNTRIES', 
        value: 'top100Countries',
        alvqa: 'list-dropdown-data-table-country'  
    },
    {
        text: 'lang_LABEL_STATISTICS_DATATABLE_DROPDOWN_TOP_100_TRACKS', 
        value: 'top100Tracks',
        alvqa: 'list-dropdown-data-table-top-100-tracks'  
    },
    {
        text: 'lang_LABEL_STATISTICS_DATATABLE_DROPDOWN_TOP_100_RELEASES', 
        value: 'top100Releases',
        alvqa: 'list-dropdown-data-table-top-100-releases'  
    },
]

export const DropdownPublishingStatisticsRightsTypes = [
    {
        text: 'lang_PUBLISHING_CAPTION_PERFORMING_RIGHTS_ABBREVIATION',
        value: 'pr',
        alvqa: 'publishing-statistics-rights-type-pr',
    },
    {
        text: 'lang_PUBLISHING_CAPTION_MECHANICAL_RIGHTS_ABBREVIATION',
        value: 'mr',
        alvqa: 'publishing-statistics-rights-type-mr',
    }
]

export const DropdownPublishingStatisticsLeftChart = [
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_SOURCES',
        value: 'bySources',
        alvqa: 'publishing-statistics-left-chart-sources',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_TYPE',
        value: 'byType',
        alvqa: 'publishing-statistics-left-chart-type',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_RIGHTS_TYPE',
        value: 'byRightsType',
        alvqa: 'publishing-statistics-left-chart-rights-type',
    },
]

export const DropdownPublishingStatisticsRightChart = [
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_TYPE',
        value: 'byType',
        alvqa: 'publishing-statistics-right-chart-type',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_SOURCES',
        value: 'bySources',
        alvqa: 'publishing-statistics-right-chart-sources',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_RIGHTS_TYPE',
        value: 'byRightsType',
        alvqa: 'publishing-statistics-right-chart-rights-type',
    },
]

export const DropdownPublishingStatisticsLicensorChart = [
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_LICENSOR',
        value: 'byLicensor',
        fallback: 'By Licensor',
        alvqa: 'publishing-statistics-chart-by-licensor',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_WORK',
        value: 'byWork',
        fallback: 'By Work',
        alvqa: 'publishing-statistics-chart-by-work',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_CHART_DROPDOWN_BY_RIGHTS_TYPE',
        value: 'byRightsType',
        fallback: 'PR vs MR',
        alvqa: 'publishing-statistics-chart-by-rights-type',
    },
]

export const DropdownPublishingStatisticsDataTable = [
    {
        text: 'lang_PUBLISHING_STATISTICS_DATATABLE_DROPDOWN_TOP_100_WORKS',
        value: 'top100Works',
        alvqa: 'publishing-statistics-data-table-top-100-works',
    },
    {
        text: 'lang_PUBLISHING_STATISTICS_DATATABLE_DROPDOWN_CONTRIBUTION_BY_LICENSOR',
        value: 'byLicensor',
        fallback: 'Contribution by Licensor',
        alvqa: 'publishing-statistics-data-table-contribution-by-licensor',
    },
]
// ERP --------------------------------------------------------------------

export const DropdownCurrencies = [
    {
        text: 'AUD',
        value: 'AUD',
        alvqa: 'dropdown-currency-aud'
    },
    {
        text: 'BRL',
        value: 'BRL',
        alvqa: 'dropdown-currency-brl'
    },
    {
        text: 'CAD',
        value: 'CAD',
        alvqa: 'dropdown-currency-cad'
    },
    {
        text: 'CHF',
        value: 'CHF',
        alvqa: 'dropdown-currency-chf'
    },
    {
        text: 'CNY',
        value: 'CNY',
        alvqa: 'dropdown-currency-cny'
    },
    {
        text: 'CZK',
        value: 'CZK',
        alvqa: 'dropdown-currency-czk'
    },
    {
        text: 'DKK',
        value: 'DKK',
        alvqa: 'dropdown-currency-dkk'
    },
    {
        text: 'EUR',
        value: 'EUR',
        alvqa: 'dropdown-currency-eur'
    },
    {
        text: 'GBP',
        value: 'GBP',
        alvqa: 'dropdown-currency-gbp'
    },
    {
        text: 'HUF',
        value: 'HUF',
        alvqa: 'dropdown-currency-huf'
    },
    {
        text: 'ILS',
        value: 'ILS',
        alvqa: 'dropdown-currency-ils'
    },
    {
        text: 'JPY',
        value: 'JPY',
        alvqa: 'dropdown-currency-jpy'
    },
    {
        text: 'KRW',
        value: 'KRW',
        alvqa: 'dropdown-currency-krw'
    },
    {
        text: 'MXN',
        value: 'MXN',
        alvqa: 'dropdown-currency-mxn'
    },
    {
        text: 'NOK',
        value: 'NOK',
        alvqa: 'dropdown-currency-nok'
    },
    {
        text: 'PLN',
        value: 'PLN',
        alvqa: 'dropdown-currency-pln'
    },
    {
        text: 'RON',
        value: 'RON',
        alvqa: 'dropdown-currency-ron'
    },
    {
        text: 'SEK',
        value: 'SEK',
        alvqa: 'dropdown-currency-sek'
    },
    {
        text: 'TRY',
        value: 'TRY',
        alvqa: 'dropdown-currency-try'
    },
    {
        text: 'USD',
        value: 'USD',
        alvqa: 'dropdown-currency-usd'
    },
    {
        text: 'ZAR',
        value: 'ZAR',
        alvqa: 'dropdown-currency-zar'
    },
]

export const DropdownErpLinkedDocumentType = [{
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_SHIPPING_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_SHIPPING_NOTE_ABBREVIATION',
        value: 'shipping',
        alvqa: 'dropdown-type-shipping-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_RETURNS_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_RETURNS_NOTE_ABBREVIATION',
        value: 'returning',
        alvqa: 'dropdown-type-returns-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_INCOMING_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_INCOMING_NOTE_ABBREVIATION',
        value: 'incoming',
        alvqa: 'dropdown-type-incoming-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_PICK_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_PICK_NOTE_ABBREVIATION',
        value: 'picking',
        alvqa: 'dropdown-type-pick-note'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_TYPE_INVOICE',
        abbr: 'lang_ERP_INVOICES_DROPDOWN_TYPE_INVOICE_ABBREVIATION',
        value: 'reg',
        alvqa: 'dropdown-type-invoice'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_TYPE_CREDIT_NOTE',
        abbr: 'lang_ERP_INVOICES_DROPDOWN_TYPE_CREDIT_NOTE_ABBREVIATION',
        value: 'ret',
        alvqa: 'dropdown-type-credit-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_SALES_DATA',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_SALES_DATA_ABBREVIATION',
        value: 'sales',
        alvqa: 'dropdown-type-sales-data'
    }
]

export const DropdownErpInventoriesValueTypes = [{
        text: 'lang_ERP_INVENTORIES_DROPDOWN_VALUE_TYPES_BIGGER_THAN_ZERO',
        value: "biggerThanZeroValues",
        alvqa: 'erp-inventories-dropdown-value-types-bigger-than-zero'
    },
    {
        text: 'lang_ERP_INVENTORIES_DROPDOWN_VALUE_TYPES_ZERO_VALUES',
        value: "zeroValues",
        alvqa: 'erp-inventories-dropdown-value-types-zero-values'
    },
    {
        text: 'lang_ERP_INVENTORIES_DROPDOWN_VALUE_TYPES_UNDEFINED_VALUES',
        value: "undefinedValues",
        alvqa: 'erp-inventories-dropdown-value-types-undefined-values'
    },
]

export const DropdownErpShippingBatches = [{
        text: 'lang_ERP_SHIPPING_DROPDOWN_BATCH_SALES',
        value: 1,
        alvqa: 'dropdown-batch-sales'
    },
    {
        text: 'lang_ERP_SHIPPING_DROPDOWN_BATCH_PROMO',
        value: 2,
        alvqa: 'dropdown-batch-promo'
    },
    {
        text: 'lang_ERP_SHIPPING_DROPDOWN_BATCH_FOC',
        value: 3,
        alvqa: 'dropdown-batch-foc'
    },
    {
        text: 'lang_ERP_SHIPPING_DROPDOWN_BATCH_PST',
        value: 5,
        alvqa: 'dropdown-batch-pst'
    },
]

export const DropdownErpInvoicesPaymentMethod = [{
        text: 'lang_ERP_INVOICES_DROPDOWN_PAYMENT_METHOD_TRANSFER',
        value: 1,
        alvqa: 'dropdown-payment-method-transfer'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_PAYMENT_METHOD_CASH',
        value: 2,
        alvqa: 'dropdown-payment-method-cash'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_PAYMENT_METHOD_CREDITCARD',
        value: 3,
        alvqa: 'dropdown-payment-method-creditcard'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_PAYMENT_METHOD_DEBIT',
        value: 4,
        alvqa: 'dropdown-payment-method-debit'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_PAYMENT_METHOD_PAYPAL',
        value: 5,
        alvqa: 'dropdown-payment-method-paypal'
    }
]

export const DropdownErpInvoicesStatus = [{
        text: 'lang_ERP_INVOICES_DROPDOWN_STATUS_DRAFT',
        value: 4,
        alvqa: 'dropdown-status-draft'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_STATUS_INPROGRESS',
        value: 5,
        alvqa: 'dropdown-status-inprogress'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_STATUS_OPEN',
        value: 1,
        alvqa: 'dropdown-status-open'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_STATUS_PAID',
        value: 2,
        alvqa: 'dropdown-status-paid'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_STATUS_OVERDUE',
        value: 3,
        alvqa: 'dropdown-status-overdue'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_STATUS_UNCOLLECTABLE',
        value: 7,
        alvqa: 'dropdown-status-uncollectable'
    }
]

export const DropdownErpInvoicesType = [{
        text: 'lang_ERP_INVOICES_DROPDOWN_TYPE_INVOICE',
        abbr: 'lang_ERP_INVOICES_DROPDOWN_TYPE_INVOICE_ABBREVIATION',
        value: 'reg',
        alvqa: 'dropdown-type-invoice'
    },
    {
        text: 'lang_ERP_INVOICES_DROPDOWN_TYPE_CREDIT_NOTE',
        abbr: 'lang_ERP_INVOICES_DROPDOWN_TYPE_CREDIT_NOTE_ABBREVIATION',
        value: 'ret',
        alvqa: 'dropdown-type-credit-note'
    }
]

export const DropdownCategory = [{
        text: "lang_GENERAL_CAPTION_ALL",
        value: "all",
        alvqa: "dropdown-publishing-contracts-split-edit-all",
      },{
        text: "lang_GENERIC_CAPTION_FOREIGN",
        value: "foreign",
        alvqa: "dropdown-publishing-contracts-split-edit-foreign",
      },
      {
        text: "lang_GENERIC_CAPTION_DOMESTIC",
        value: "domestic",
        alvqa: "dropdown-publishing-contracts-split-edit-domestic",
      },
    ];


export const DropdownWeighting = [
    { header: "lang_CONTRACTS_PUBLISHING_CAPTION_WEIGHTED_BY_DIVIDER_AUV" },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_PR_CONTRACTING_PARTNER",
        value: "prContractingShares",
        alvqa: "dropdown-publishing-contracts-split-edit-by-pr-contracting-shares",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_MR_CONTRACTING_PARTNER",
        value: "mrContractingShares",
        alvqa: "dropdown-publishing-contracts-split-edit-by-mr-contracting-shares",
    },
    { header: "lang_CONTRACTS_PUBLISHING_CAPTION_WEIGHTED_BY_DIVIDER_SLG" },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_PR_SUBPUBLISHER",
        value: "prSubpublisherShares",
        alvqa: "dropdown-publishing-contracts-split-edit-by-pr-subpublisher-shares",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_MR_SUBPUBLISHER",
        value: "mrSubpublisherShares",
        alvqa: "dropdown-publishing-contracts-split-edit-by-mr-subpublisher-shares",
    },
    { header: "lang_CONTRACTS_PUBLISHING_CAPTION_WEIGHTED_BY_DIVIDER_PVV" },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_WEIGHTED_BY_PR_OF_SELECTED_AUTHOR_ALL_UVZ",
        value: "prSelectedAuthorAllUvz",
        alvqa: "dropdown-publishing-contracts-split-edit-by-pr-selected-author-all-uvz",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_WEIGHTED_BY_PR_OF_SELECTED_AUTHOR_UVZ_OF_AZENTRY",
        value: "prSelectedAuthorAzUvz",
        alvqa: "dropdown-publishing-contracts-split-edit-by-pr-selected-author-az-uvz",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_WEIGHTED_BY_MR_OF_SELECTED_AUTHOR_ALL_UVZ",
        value: "mrSelectedAuthorAllUvz",
        alvqa: "dropdown-publishing-contracts-split-edit-by-mr-selected-author-all-uvz",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_CONDITIONS_SPLITS_WEIGHTED_BY_MR_OF_SELECTED_AUTHOR_UVZ_OF_AZENTRY",
        value: "mrSelectedAuthorAzUvz",
        alvqa: "dropdown-publishing-contracts-split-edit-by-mr-selected-author-az-uvz",
    },
    { header: "lang_CONTRACTS_PUBLISHING_CAPTION_WEIGHTED_BY_DIVIDER_NONE" },
    {
        text: "lang_GENERIC_CAPTION_NONE",
        value: null,
        alvqa: "dropdown-publishing-contracts-split-edit-by-role",
    },
];

export const DropdownWeightingSource = [
    {
        text: "lang_GENERIC_CAPTION_ROLE_PERCENT",
        value: "role",
        alvqa: "dropdown-publishing-contracts-split-edit-source-role",
    },
    {
        text: "lang_GENERIC_CAPTION_INTL_PERCENT",
        value: "intl",
        alvqa: "dropdown-publishing-contracts-split-edit-source-intl",
    },
    {
        text: "lang_GENERIC_CAPTION_OWN_PERCENT",
        value: "own",
        alvqa: "dropdown-publishing-contracts-split-edit-source-own",
    },
];

export const DropdownSharesToConsider = [
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_ALL_WITH_PWR",
        value: "pwr",
        alvqa: "dropdown-publishing-contracts-split-edit-shares-to-consider-pwr",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_ALL_WITH_PWR_SPLIT_50_50",
        value: "pwr50",
        alvqa: "dropdown-publishing-contracts-split-edit-shares-to-consider-pwr50",
    },
    {
        text: "lang_CONTRACTS_PUBLISHING_CAPTION_WITH_CONTRACTS_ONLY",
        value: "contractsOnly",
        alvqa: "dropdown-publishing-contracts-split-edit-shares-to-consider-contracts-only",
    },
];

export const DropdownRightsType = [{
        text: "lang_GENERAL_CAPTION_ALL",
        value: "all",
        alvqa: "dropdown-publishing-contracts-split-edit-right-all",
    },{
        text: "lang_PUBLISHING_CAPTION_PERFORMING_RIGHTS_ABBREVIATION",
        value: "pr",
        alvqa: "dropdown-publishing-contracts-split-edit-right-pr",
    },
    {
        text: "lang_PUBLISHING_CAPTION_MECHANICAL_RIGHTS_ABBREVIATION",
        value: "mr",
        alvqa: "dropdown-publishing-contracts-split-edit-right-mr",
    },
    {
        text: "lang_GENERIC_CAPTION_SYNCH",
        value: "synch",
        alvqa: "dropdown-publishing-contracts-split-edit-right-synch",
    },
    {
        text: "lang_PUBLISHING_CONTRACTS_CAPTION_RIGHTS_TYPE_FROM_CATEGORY",
        value: "fromCategory",
        alvqa: "dropdown-publishing-contracts-split-edit-right-from-category",
    },
]

export const DropdownErpInvoicesLanguages = [{
        text: 'lang_GENERAL_OPTION_DE',
        abbr: 'lang_GENERAL_OPTION_DE',
        value: 'de',
        alvqa: 'dropdown-language-option-de'
    },
    {
        text: 'lang_GENERAL_OPTION_EN',
        abbr: 'lang_GENERAL_OPTION_EN',
        value: 'en',
        alvqa: 'dropdown-language-option-en'
    }
]
// Used for C3 testing for AZ person metadata languages
export const DropdownAzMetadataLanguages = [
    {
        text: 'English',
        abbr: 'lang_GENERAL_OPTION_EN',
        value: 'en',
        alvqa: 'dropdown-language-option-en'
    },
    {
        text: 'Deutsch',
        abbr: 'lang_GENERAL_OPTION_DE',
        value: 'de',
        alvqa: 'dropdown-language-option-de'
    },
    {
        text: '日本語',
        abbr: 'lang_GENERAL_OPTION_JA',
        value: 'ja',
        alvqa: 'dropdown-language-option-ja'
    },
    {
        text: '한국어',
        abbr: 'lang_GENERAL_OPTION_KO',
        value: 'ko',
        alvqa: 'dropdown-language-option-ko'
    }
]

export const DropdownErpInvoicesSalesTypesPublishing = [
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_NOSTATEMENT',
        value: 18,
        alvqa: 'dropdown-sales-type-nostatement'
    },
    {
        text: 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_PRINTING',
        value: 19,
        alvqa: 'dropdown-sales-type-pc-printing'
    },
    {
        text: 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_ARRANGEMENT',
        value: 20,
        alvqa: 'dropdown-sales-type-pc-arrangement'
    },
    {
        text: 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_BIG_RIGHT',
        value: 21,
        alvqa: 'dropdown-sales-type-pc-big-right'
    },
    {
        text: 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_SHEET',
        value: 22,
        alvqa: 'dropdown-sales-type-pc-sheet'
    },
    {
        text: 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_SYN',
        value: 23,
        alvqa: 'dropdown-sales-type-pc-synch'
    },
    {
        text: 'lang_GENERAL_CAPTION_TYPE_OF_RIGHTS_SYN_FOREIGN',
        value: 24,
        alvqa: 'dropdown-sales-type-pc-synch-foreign'
    },
]

export const DropdownErpShippingStatus = [{
        text: 'lang_ERP_SHIPPING_DROPDOWN_STATUS_DRAFT',
        value: 'draft',
        alvqa: 'dropdown-status-draft'
    },
    {
        text: 'lang_ERP_SHIPPING_DROPDOWN_STATUS_OPEN',
        value: 'recorded',
        alvqa: 'dropdown-status-open'
    }
]

export const DropdownErpShippingType = [{
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_INCOMING_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_INCOMING_NOTE_ABBREVIATION',
        value: 'incoming',
        alvqa: 'dropdown-type-incoming-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_SHIPPING_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_SHIPPING_NOTE_ABBREVIATION',
        value: 'shipping',
        alvqa: 'dropdown-type-shipping-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_PICK_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_PICK_NOTE_ABBREVIATION',
        value: 'picking',
        alvqa: 'dropdown-type-pick-note'
    },
    {
        text: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_RETURNS_NOTE',
        abbr: 'lang_ERP_INVOICES_LINKED_DOCUMENT_TYPE_RETURNS_NOTE_ABBREVIATION',
        value: 'returning',
        alvqa: 'dropdown-type-returns-note'
    },
]

// A-Z
// NOT USED, yet - TODO_PT REFACTOR A-Z TYPE dropdowns to use lang const and be in FE
export const DropdownAzTypes = [{
        text: 'lang_AZ_DROPDOWN_TYPE_WAREHOUSE',
        value: 'warehouse',
        alvqa: 'dropdown-type-warehouse'
    },
    {
        text: 'lang_AZ_DROPDOWN_TYPE_WAREHOUSE_OWN',
        value: 'warehouseOwn',
        alvqa: 'dropdown-type-warehouse-own'
    }
]

export const DropdownAzTaxWaiver = [{
        text: 'lang_GENERIC_AZ_CAPTION_TAX_WAIVER_NOT_REQUIRED',
        value: 0,
        alvqa: 'tax-waiver-not-required'
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_TAX_WAIVER_REQUIRED_NOT_PROVIDED',
        value: 1,
        alvqa: 'tax-waiver-required-not-provided'
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_TAX_WAIVER_REQUIRED_AND_PROVIDED',
        value: 2,
        alvqa: 'tax-waiver-required-and-provided'
    }
]

export const DropdownAzRecoupmentPriority = [
    {
        text: 'lang_AZ_CAPTION_RECOUPMENT_PRIORITY_ADVANCES_FIRST',
        value: 'advancesFirst',
        alvqa: 'recoupment-priority-advances-first'
    },
    {
        text: 'lang_AZ_CAPTION_RECOUPMENT_PRIORITY_NEGATIVE_BALANCES_FIRST',
        value: 'negativeBalancesFirst',
        alvqa: 'recoupment-priority-negative-balances-first'
    }
]

export const DropdownFormatNameAdressTypes = [{
        text: 'lang_AZ_DROPDOWN_FORMAT_NAME_ADDRESS_EUROPEAN',
        value: 'european',
        alvqa: 'dropdown-format-name-address-european'
    },
    {
        text: 'lang_AZ_DROPDOWN_FORMAT_NAME_ADDRESS_JAPANESE',
        value: 'japanese',
        alvqa: 'dropdown-format-name-address-japanese'
    },
    {
        text: 'lang_AZ_DROPDOWN_FORMAT_NAME_ADDRESS_KOREAN',
        value: 'korean',
        alvqa: 'dropdown-format-name-address-korean'
    },
    {
        text: 'lang_AZ_DROPDOWN_FORMAT_NAME_ADDRESS_AMERICAN',
        value: 'american',
        alvqa: 'dropdown-format-name-address-american'
    }
]

// AZ Distributors
export const DropdownAzDistributorsType = [{
        text: 'lang_GENERIC_AZ_CAPTION_DISTRIBUTOR_ON_COMMISSION',
        value: 'kommissionsvertrieb',
        alvqa: 'az-distributors-type-'
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_LICENSEE',
        value: 'Lizenznehmer',
        alvqa: 'tax-waiver-not-required'
    },
]

// CONTRACTS Publishing
export const DropdownContractsPublishingApplyTo = [{
    "value": "revenue",
    "text": "lang_PUBLISHING_CONTRACTS_ROWS_APPLY_TO_INCOMING"
    },
    {
        "value": "lizenz",
        "text": "lang_PUBLISHING_CONTRACTS_ROWS_APPLY_TO_LICENSOR"
    },
    {
        "value": "company",
        "text": "lang_PUBLISHING_CONTRACTS_ROWS_APPLY_TO_PUBLISHER"
    },
    {
        "value": "at_source",
        "text": "lang_PUBLISHING_CONTRACTS_ROWS_APPLY_TO_SOURCE"
    }
]

export const DropdownContractsPublishingSplitsApplyTo = [
    {
        "value": "incomingMoney",
        "text": "lang_PUBLISHING_CONTRACTS_ROWS_APPLY_TO_INCOMING"
    },
    {
        "value": "byAlvId",
        "text": "lang_PUBLISHING_CONTRACTS_ROWS_APPLY_TO_BY_ALVID"
    },
]

export const DropdownContractsPublishingSplitsOrder = [
    {
        "value": "before",
        "text": "lang_PUBLISHING_CONTRACTS_ROWS_ORDER_BEFORE"
    },
]

// CONTRACTS Label
export const DropdownContractsLabelSalesType = [{
        value: 1,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_RETAIL',
        alvqa: 'dropdown-sales-type-retail'
    },
    {
        value: 2,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_STREAM',
        alvqa: 'dropdown-sales-type-digital-stream'
    },
    {
        value: 3,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_DOWNLOAD',
        alvqa: 'dropdown-sales-type-digital-download'
    },
    {
        value: 4,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE',
        alvqa: 'dropdown-sales-type-license'
    },
    {
        value: 5,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE_MAILORDER',
        alvqa: 'dropdown-sales-type-license-mail-order'
    },
    {
        value: 6,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE_DIGITAL',
        alvqa: 'dropdown-sales-type-license-digital'
    },
    {
        value: 7,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE_RETAIL',
        alvqa: 'dropdown-sales-type-license-retail'
    },
    {
        value: 8,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_MEDIA_PROMOTION',
        alvqa: 'dropdown-sales-type-media-promotion'
    },
    {
        value: 9,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE_MEDIA_PROMOTION',
        alvqa: 'dropdown-sales-type-license-media-promotion'
    },
    {
        value: 11,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_STREAM_AND_DOWNLOAD',
        alvqa: 'dropdown-sales-type-stream-and-download'
    },
    {
        value: 12,
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_DIRECT_SALES',
        alvqa: 'dropdown-sales-type-direct-sales'
    },
    {
        value: 10,
        text: 'lang_GENERIC_CAPTION_ALL',
        alvqa: 'dropdown-sales-type-all'
    },
]

export const DropdownLabelContractsContractTypes = [{
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_BUV',
        value: 'BUV',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-buv'
    },
    {
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_KVT',
        value: 'KVT',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-kvt'
    },
    {
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_LVT',
        value: 'LVT',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-lvt'
    },
    {
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_LZT',
        value: 'LZT',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-lzt'
    },
    {
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_PVT',
        value: 'PVT',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-pvt'
    },
    {
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_SVT',
        value: 'SVT',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-svt'
    },
    {
        text: 'lang_CONTRACTS_LABEL_CONTRACT_TYPE_OPTION_VVT',
        value: 'VVT',
        alvqa: 'label-contracts-list-row-dropdown-contract-type-vvt'
    }
]

export const DropdownLabelContractsBillingCycles = [{
        text: "lang_CONTRACTS_LABEL_STATEMENT_SCHEDULE_OPTION_MONTHLY",
        value: "Monat",
        alvqa: 'label-contracts-dropdown-billing-cycle-month'
    },
    {
        text: "lang_CONTRACTS_LABEL_STATEMENT_SCHEDULE_OPTION_QUARTERLY",
        value: "Quartal",
        alvqa: 'label-contracts-dropdown-billing-cycle-quarter'
    },
    {
        text: "lang_CONTRACTS_LABEL_STATEMENT_SCHEDULE_OPTION_HALFYEARLY",
        value: "Halbjahr",
        alvqa: 'label-contracts-dropdown-billing-cycle-halfyear'
    },
    {
        text: "lang_CONTRACTS_LABEL_STATEMENT_SCHEDULE_OPTION_YEARLY",
        value: "Jahr",
        alvqa: 'label-contracts-dropdown-billing-cycle-year'
    }
]
export const DropdownLabelContractsResolutionPeriods = [{
        text: "lang_CONTRACTS_LABEL_RESERVE_SETTLES_OPTION_QUARTER",
        value: "3",
        alvqa: 'label-contracts-dropdown-resolution-period-quarter'
    },
    {
        text: "lang_CONTRACTS_LABEL_RESERVE_SETTLES_OPTION_HALFYEAR",
        value: "6",
        alvqa: 'label-contracts-dropdown-resolution-period-halfyear'
    },
    {
        text: "lang_CONTRACTS_LABEL_RESERVE_SETTLES_OPTION_YEAR",
        value: "12",
        alvqa: 'label-contracts-dropdown-resolution-period-year'
    }
]

export const DropdownContractsLabelLicense = [{
        value: 1,
        text: "lang_GENERIC_LABEL_CAPTION_MSP",
        alvqa: 'dropdown-license-msp'
    },
    {
        value: 2,
        text: 'lang_GENERIC_LABEL_CAPTION_PPD',
        alvqa: 'dropdown-license-ppd'
    },
    {
        value: 3,
        text: 'lang_GENERIC_LABEL_CAPTION_WHP',
        alvqa: 'dropdown-license-whp'
    },
    {
        value: 4,
        text: 'lang_GENERIC_LABEL_CAPTION_NET',
        alvqa: 'dropdown-license-net'
    },
    {
        value: 5,
        text: 'lang_GENERIC_LABEL_CAPTION_UNIT',
        alvqa: 'dropdown-license-unit'
    },
    {
        value: 6,
        text: 'lang_GENERIC_LABEL_CAPTION_NBD',
        alvqa: 'dropdown-license-nbd'
    },
    {
        value: 7,
        text: 'lang_GENERIC_LABEL_CAPTION_SRP',
        alvqa: 'dropdown-license-srp'
    }
]

export const DropdownContractsLabelSalesUnits = [{
        value: 'track',
        text: 'Track',
        alvqa: 'dropdown-sales-unit-track'
    },
    {
        value: 'bundle',
        text: 'Bundle',
        alvqa: 'dropdown-sales-unit-bundle'
    }
]

export const DropdownContractsLabelReturnReserveCycle = [{
        text: "lang_CONTRACTS_LABEL_RESERVE_SETTLES_OPTION_QUARTER",
        value: 3,
        alvqa: "dropdown-return-reserve-cycle-period-quarter"
    },
    {
        text: "lang_CONTRACTS_LABEL_RESERVE_SETTLES_OPTION_HALFYEAR",
        value: 6,
        alvqa: "dropdown-return-reserve-cycle-period-halfyear"
    },
    {
        text: "lang_CONTRACTS_LABEL_RESERVE_SETTLES_OPTION_YEAR",
        value: 12,
        alvqa: "dropdown-return-reserve-cycle-period-year"
    }
]

export const DropdownContractsLabelPriceCategories = [{
        text: 'lang_GENERAL_CAPTION_ALL',
        value: 'all',
        alvqa: 'dropdown-price-category-all'
    },
    {
        text: 'lang_GENERAL_PRICE_CATEGORY_BUDGET',
        value: 'budget',
        alvqa: 'dropdown-price-category-budget'
    },
    {
        text: 'lang_GENERAL_PRICE_CATEGORY_MIDPRICE',
        value: 'midprice',
        alvqa: 'dropdown-price-category-midprice'
    },
    {
        text: 'lang_GENERAL_PRICE_CATEGORY_HIGHPRICE',
        value: 'highprice',
        alvqa: 'dropdown-price-category-highprice'
    },
]

// LABEL RELEASES
export const DropdownLabelReleasesPromotionalTextType = [{
        text: 'lang_LABEL_RELEASES_PROMOTIONAL_TEXT_TYPE_LONG',
        value: 'long',
        alvqa: 'dropdown-type-long-description'
    },
    {
        text: 'lang_LABEL_RELEASES_PROMOTIONAL_TEXT_TYPE_SHORT',
        value: 'short',
        alvqa: 'dropdown-type-short-description'
    }
]
export const DropdownLabelReleasesDigitalDistributionStatus = [
    // {
    //     text: 'lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_RELEASED', 
    //     value: 'released',
    //     alvqa: 'dropdown-status-released'
    // },
    {
        text: 'lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_PENDING',
        value: 'pending',
        alvqa: 'dropdown-status-pending'
    },
    {
        text: 'lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_QUALITYCHECK',
        value: 'qualityCheck',
        alvqa: 'dropdown-status-in-quality-check'
    },
    // {
    //     text: 'Ausgeliefert', 
    //     value: 'delivered',
    //     alvqa: 'dropdown-status-delivered'
    // }
]

export const DropdownLabelReleasesBudgetGroupTypes = [{
        text: 'lang_GENERIC_COST_GROUP_TYPE_MANUFACTURING',
        value: 'manufacturing',
        group: 'costs',
        alvqa: 'dropdown-budget-group-manufacturing'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_ADVERTISING',
        value: 'advertising',
        group: 'costs',
        alvqa: 'dropdown-budget-group-advertising'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_MARKETING',
        value: 'marketing',
        group: 'costs',
        alvqa: 'dropdown-budget-group-marketing'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_PROMOTION',
        value: 'promotion',
        group: 'costs',
        alvqa: 'dropdown-budget-group-promotion'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_PRODUCTION',
        value: 'production',
        group: 'costs',
        alvqa: 'dropdown-budget-group-production'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_OTHER',
        value: 'costsOther',
        group: 'costs',
        alvqa: 'dropdown-budget-group-other'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_LIVE',
        value: 'costsLive',
        group: 'costs',
        alvqa: 'dropdown-budget-group-live'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_ADVANCE',
        value: 'advance',
        group: 'costs',
        alvqa: 'dropdown-budget-group-advance'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_LICENSES',
        value: 'licenses',
        group: 'costs',
        alvqa: 'dropdown-budget-group-licenses '
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_MECHANICALS',
        value: 'mechanicals',
        group: 'costs',
        alvqa: 'dropdown-budget-group-mechanicals'
    },
    {
        text: 'lang_LABEL_RELEASES_BUDGET_GROUP_TYPE_PHYSICAL',
        value: 'physical',
        group: 'income',
        alvqa: 'dropdown-budget-group-physical'
    },
    {
        text: 'lang_LABEL_RELEASES_BUDGET_GROUP_TYPE_DOWNLOAD',
        value: 'download',
        group: 'income',
        alvqa: 'dropdown-budget-group-download'
    },
    {
        text: 'lang_LABEL_RELEASES_BUDGET_GROUP_TYPE_STREAMING',
        value: 'streaming',
        group: 'income',
        alvqa: 'dropdown-budget-group-streaming'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_OTHER',
        value: 'incomeOther',
        group: 'income',
        alvqa: 'dropdown-budget-group-income-other'
    },
    {
        text: 'lang_GENERIC_COST_GROUP_TYPE_LIVE',
        value: 'incomeLive',
        group: 'income',
        alvqa: 'dropdown-budget-group-income-live'
    },
]

export const DropdownLabelReleasesProductionTypeOptions = [{
        text: "lang_PUBLISHING_RELEASES_CAPTION_FILM",
        value: 1,
        group: "lang_PUBLISHING_RELEASES_CAPTION_CINEMA",
        alvqa: 'publishing-relases-edit-form-dropdown-production-type-film'

    },
    {
        text: "lang_PUBLISHING_RELEASES_CAPTION_SHORT_FILM",
        value: 2,
        group: "lang_PUBLISHING_RELEASES_CAPTION_CINEMA",
        alvqa: 'publishing-relases-edit-form-dropdown-production-type-short-film'
    },
    {
        text: "lang_PUBLISHING_RELEASES_CAPTION_INHOUSE_COMMISSIONED_PRODUCTION",
        value: 3,
        group: "lang_PUBLISHING_RELEASES_CAPTION_TELEVISION",
        alvqa: 'publishing-relases-edit-form-dropdown-production-type-inhouse-commissioned-production'
    },
    {
        text: "lang_PUBLISHING_RELEASES_CAPTION_SHOW",
        value: 4,
        group: "lang_PUBLISHING_RELEASES_CAPTION_TELEVISION",
        alvqa: 'publishing-relases-edit-form-dropdown-production-type-show'
    },
    {
        text: "lang_PUBLISHING_RELEASES_CAPTION_OTHER_TELEVISION_PRODUCTION",
        value: 5,
        group: "lang_PUBLISHING_RELEASES_CAPTION_TELEVISION",
        alvqa: 'publishing-relases-edit-form-dropdown-production-type-television'
    }
]

export const DropdownLabelReleasesLicensesOptions = [
    {
        text: 'lang_GENERIC_LABEL_CAPTION_NET',
        value: 'net',
        alvqa: 'dropdown-license-net'
    },
    {
        text: 'lang_GENERIC_LABEL_CAPTION_PPD',
        value: 'ppd',
        alvqa: 'dropdown-license-ppd'
    },
    {
        text: 'lang_GENERIC_LABEL_CAPTION_MSP',
        value: 'msp',
        alvqa: 'dropdown-license-msp'
    },
    {
        text: 'lang_GENERIC_LABEL_CAPTION_WHP',
        value: 'whp',
        alvqa: 'dropdown-license-whp'
    },
    {
        text: 'lang_GENERIC_LABEL_CAPTION_UNIT',
        value: 'stck',
        alvqa: 'dropdown-license-stck'
    },
]

export const DropdownLabelReleasesSalesTypeOptions = [
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_RETAIL',
        value: 'retail',
        alvqa: 'dropdown-sales-type-retail'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_DOWNLOAD',
        value: 'download',
        alvqa: 'dropdown-sales-type-download'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_STREAM',
        value: 'stream',
        alvqa: 'dropdown-sales-type-stream'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_LICENSE',
        value: 'license',
        alvqa: 'dropdown-sales-type-license'
    },
    {
        text: 'lang_GENERIC_LABEL_DROPDOWN_SALES_TYPE_DIRECT_SALES',
        value: 'directSales',
        alvqa: 'dropdown-sales-type-directSales'
    },
]


// ACCOUNT

export const DropdownFormalSalutation = [{
        text: 'lang_ACCOUNT_SWITCH_ADDRESS_FORMAL',
        value: 'yes',
        alvqa: 'dropdown-address-formal'
    },
    {
        text: 'lang_ACCOUNT_SWITCH_ADDRESS_INFORMAL',
        value: 'no',
        alvqa: 'dropdown-address-informal'
    },
]

export const DropdownCompaniesRoles = [{
        text: 'lang_ACCOUNT_COMPANIES_DROPDOWN_ROLE_OPTION_OWNER',
        value: 'owner',
        alvqa: 'dropdown-role-owner'
    },
    {
        text: 'lang_ACCOUNT_COMPANIES_DROPDOWN_ROLE_OPTION_ACCOUNTANT',
        value: 'accountant',
        alvqa: 'dropdown-role-accountant'
    },
]

export const DropdownNumberFormats = [{
        text: 'lang_ACCOUNT_COMPANIES_DROPDOWN_NUMBER_FORMAT_OPTION_AMERICAN',
        value: 'US',
        alvqa: 'dropdown-number-format-american'
    },
    {
        text: 'lang_ACCOUNT_COMPANIES_DROPDOWN_NUMBER_FORMAT_OPTION_EUROPEAN',
        value: 'EU',
        alvqa: 'dropdown-number-format-european'
    },
]

export const DropdownAccountCredentialsType = [{
        text: 'lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_ALV_LOGIN',
        value: 'alv-login', // 2
        alvqa: 'account-credentials-type-alv-login'
    },
    // {
    //     text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_GEMA_IWA_WEBSERVICE', 
    //     value: 'gema-iwa-webservice',
    //     alvqa: 'account-credentials-type-gema-iwa-webservice'
    // },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_AKM_CWR',
        value: 'akm-cwr',
        alvqa: 'account-credentials-type-akm-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_CAPASSO_CWR',
        value: 'capasso-cwr',
        alvqa: 'account-credentials-type-capasso-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_GEMA_CWR',
        value: 'gema-cwr',
        alvqa: 'account-credentials-type-gema-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_GEMA_SOUNDFILE_API',
        value: 'gema-soundfile', // 1
        alvqa: 'account-credentials-type-gema-soundfile'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_ICE_CWR',
        value: 'ice-cwr',
        alvqa: 'account-credentials-type-ice-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_MLC_CWR',
        value: 'mlc-cwr',
        alvqa: 'account-credentials-type-mlc-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_MUSICMARK_CWR',
        value: 'musicmark-cwr',
        alvqa: 'account-credentials-type-musicmark-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_SACEM_CWR',
        value: 'sacem-cwr',
        alvqa: 'account-credentials-type-sacem-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_SUISA_CWR',
        value: 'suisa-cwr',
        alvqa: 'account-credentials-type-suisa-cwr'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_UBC_CWR',
        value: 'ubc-cwr',
        alvqa: 'account-credentials-type-ubc-cwr'
    },
    {
        text: 'lang_GENERIC_CAPTION_MAILCHIMP',
        value: 'mailchimp',
        alvqa: 'account-credentials-type-mailchimp'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_AV_MELDUNG_API', 
        value: 'av-meldung-api',
        alvqa: 'account-credentials-type-av-meldung-api'
    },
    {
        text: 'lang_GENERIC_CAPTION_HELPJUICE', 
        value: 'helpjuice',
        alvqa: 'account-credentials-type-helpjuice'
    },
]

export const DropdownAccountCredentialsRole = [{
        text: 'lang_ACCOUNT_CREDENTIALS_ROLE_OPTION_ADMIN',
        value: 'admin',
        alvqa: 'account-credentials-role-admin'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_ROLE_OPTION_COWORKER',
        value: 'coworker',
        alvqa: 'account-credentials-role-coworker'
    },
    {
        text: 'lang_ACCOUNT_CREDENTIALS_ROLE_OPTION_ASSISTANT',
        value: 'assistant',
        alvqa: 'account-credentials-role-assistant'
    },
]

export const DropdownAccountMappingsDirectionsOptions = [{
        text: 'lang_GENERIC_CAPTION_IMPORT',
        value: 'import',
        alvqa: 'account-mappings-direction-import'
    },
    {
        text: 'lang_GENERIC_CAPTION_EXPORT', 
        value: 'export',
        alvqa: 'account-mappings-direction-export'
    },
]

export const DropdownAccountMappingsPublishingRightsTypes = [{
        text: 'lang_GENERIC_CAPTION_PR',
        value: 'pr',
        alvqa: 'account-mappings-rights-type-pr'
    },
    {
        text: 'lang_GENERIC_CAPTION_MR',
        value: 'mr',
        alvqa: 'account-mappings-rights-type-mr'
    },
]

export const DropdownAccountMappingsDecimalSeparatorOptions = [{
        text: 'lang_GENERIC_CAPTION_DECIMAL_SEPARATOR_COMMA',
        value: 'comma',
        alvqa: 'account-mappings-decimal-separator-comma'
    },
    {
        text: 'lang_GENERIC_CAPTION_DECIMAL_SEPARATOR_DOT',
        value: 'dot',
        alvqa: 'account-mappings-decimal-separator-dot'
    },
]

export const DropdownAccountMappingsFileFormatOptions = [{
        text: 'lang_GENERIC_CAPTION_CSV',
        value: 'csv',
        alvqa: 'account-mappings-file-format-csv'
    },
    {
        text: 'lang_GENERIC_CAPTION_EXCEL',
        value: 'xlsx',
        alvqa: 'account-mappings-file-format-excel'
    },
]

export const DropdownAccountMappingsDelimiterOptions = [
    {
        text: 'lang_GENERIC_CAPTION_COMMA',
        value: 'comma',
        alvqa: 'account-mappings-delimiter-comma'
    },
    {
        text: 'lang_GENERIC_CAPTION_SEMICOLON',
        value: 'semicolon',
        alvqa: 'account-mappings-delimiter-semicolon'
    },
    {
        text: 'lang_GENERIC_CAPTION_TAB',
        value: 'tab',
        alvqa: 'account-mappings-delimiter-tab'
    },
]

export const DropdownAccountMappingsFileEncodingOptions = [
    {
        text: 'lang_ACCOUNT_MAPPINGS_FILE_ENCODING_AUTO',
        value: null,
        alvqa: 'account-mappings-file-encoding-auto'
    },
    {
        text: 'lang_ACCOUNT_MAPPINGS_FILE_ENCODING_UTF8',
        value: 'UTF-8',
        alvqa: 'account-mappings-file-encoding-utf8'
    },
    {
        text: 'lang_ACCOUNT_MAPPINGS_FILE_ENCODING_SJIS',
        value: 'SJIS',
        alvqa: 'account-mappings-file-encoding-sjis'
    },
]

export const DropdownAccountMappingsDomainsOptions = [
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_WORKS',
        value: 'publishing_works',
        alvqa: 'account-mappings-domain-publishing-works',
        direction: 'export'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_WORKS',
        value: 'publishing_works',
        alvqa: 'account-mappings-domain-publishing-works',
        direction: 'import'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_SHEETS',
        value: 'publishing_sheets',
        alvqa: 'account-mappings-domain-publishing-sheets',
        direction: 'export'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_PROJECTS',
        value: 'publishing_projects',
        alvqa: 'account-mappings-domain-publishing-projects',
        direction: 'import'
    },
    {
        text: 'lang_ACCOUNT_MAPPINGS_DROPDOWN_DOMAIN_PUBLISHING_INCOME', 
        value: 'publishing_income',
        alvqa: 'account-mappings-domain-publishing-income',
        direction: 'import'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_STATEMENTS',
        value: 'publishing_statements',
        alvqa: 'account-mappings-domain-publishing-statements',
        direction: 'export'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_PAYEE_STATEMENT',
        value: 'publishing_payee_statement',
        alvqa: 'account-mappings-domain-publishing-payee-statement',
        direction: 'export'
    },
    {
        text: 'lang_PUBLISHING_USAGE_CAPTION_BROADCAST_SCHEDULE',
        value: 'publishing_broadcast_events',
        alvqa: 'account-mappings-domain-publishing-broadcast-events',
        direction: 'import'
    },
    {
        text: 'lang_PUBLISHING_USAGE_CAPTION_USAGE_STATEMENT',
        value: 'publishing_usage_records',
        alvqa: 'account-mappings-domain-publishing-usage-records',
        direction: 'import'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_PUBLISHING_COMPLAINTS',
        value: 'publishing_complaints',
        alvqa: 'account-mappings-domain-publishing-complaints',
        direction: 'export'
    },
    {
        text: "lang_GENERIC_CAPTION_DOMAIN_LABEL_TRACKS",
        value: 'label_tracks',
        alvqa: 'account-mappings-domain-label-tracks',
        direction: 'import'
    },
    {
        text: "lang_GENERIC_CAPTION_DOMAIN_LABEL_RELEASES",
        value: 'label_releases',
        alvqa: 'account-mappings-domain-label-releases',
        direction: 'import'
    },
    {
        text: "lang_GENERIC_CAPTION_DOMAIN_LABEL_RELEASES",
        value: 'label_releases',
        alvqa: 'account-mappings-domain-label-releases',
        direction: 'export'
    },
    {
        text: 'lang_ACCOUNT_MAPPINGS_DROPDOWN_DOMAIN_LABEL_SALES_DATA',
        value: 'label_sales_data',
        alvqa: 'account-mappings-domain-label-sales-data',
        direction: 'import'
    },
    {
        text: 'lang_GENERIC_CAPTION_INTERESTS_LABEL_ROYALTY_STATEMENTS',
        value: 'label_statements',
        alvqa: 'account-mappings-domain-label-statements',
        direction: 'export'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_AZ_PERSONS',
        value: 'az_persons',
        alvqa: 'account-mappings-domain-az-persons',
        direction: 'import'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_CONTRACTS_PUBLISHING',
        value: 'contracts_publishing',
        alvqa: 'account-mappings-domain-contracts-publishing',
        direction: 'export'
    },
    {
        text: 'lang_GENERIC_CAPTION_DOMAIN_CONTRACTS_LABEL',
        value: 'contracts_label',
        alvqa: 'account-mappings-domain-contracts-label',
        direction: 'export'
    }
]

export const DropdownAccountMappingsSourcesOptions = [
    {
        text: 'lang_GENERIC_CAPTION_MANU_PERCENT',
        value: 'osMANU',
        alvqa: 'account-mappings-source-original-shares-manu'
    },
    {
        text: 'lang_GENERIC_CAPTION_ROLE_PERCENT',
        value: 'osROLE',
        alvqa: 'account-mappings-source-original-shares-role'
    },
    {
        text: 'lang_GENERIC_CAPTION_INTL_PERCENT',
        value: 'osINTL',
        alvqa: 'account-mappings-source-original-shares-intl'
    },
    {
        text: 'lang_GENERIC_CAPTION_OWN_PERCENT',
        value: 'osOWN',
        alvqa: 'account-mappings-source-original-shares-own'
    },
]

export const DropdownAccountMappingsMaintainersOptions = [{
        text: 'lang_ACCOUNT_MAPPINGS_MAINTAINERS_OPTION_ALVDIGITAL',
        value: 'alvdigital',
        alvqa: 'account-mappings-maintainer-alvdigital'
    },
    {
        text: 'lang_ACCOUNT_MAPPINGS_MAINTAINERS_OPTION_ALVUSER',
        value: 'alvuser',
        alvqa: 'account-mappings-maintainer-alvuser'
    },
    {
        text: 'lang_ACCOUNT_MAPPINGS_CAPTION_FILTER_OPTION_MAINTAINER_SELF',
        value: 'self',
        alvqa: 'account-mappings-maintainer-self'
    },
]
export const DropdownAzPersonsCommunicationsType = [
    {
        text: 'lang_GENERIC_CAPTION_EMAIL',
        value: 'email',
        alvqa: 'drodown-type-email'
    },
    {        
        text: 'lang_GENERIC_CAPTION_MEETING',
        value: 'meeting',
        alvqa: 'drodown-type-meeting'
    },
    {        
        text: 'lang_GENERIC_CAPTION_ONLINE_MEETING',
        value: 'onlineMeeting',
        alvqa: 'drodown-type-online-meeting'
    },
    {        
        text: 'lang_GENERIC_CAPTION_OTHERS',
        value: 'other',
        alvqa: 'drodown-type-other'
    },
    {        
        text: 'lang_GENERIC_CAPTION_PHONE',
        value: 'phone',
        alvqa: 'drodown-type-phone'
    },
    {        
        text: 'lang_GENERIC_CAPTION_POSTAL_MAIL',
        value: 'postal',
        alvqa: 'drodown-type-postal'
    },
]
export const DropdownAzPersonsOtherIdsTypes = [
    {
        text: "lang_GENERIC_CAPTION_RECIPIENT_ID",
        value: "recipientId",
        alvqa: 'type-option-recipient-id'
    },
    {
        text: "lang_AZ_PERSONS_CAPTION_OTHER_IDS_TYPE_PSEUDONYM",
        value: "pseudonym",
        alvqa: 'type-option-pseudonym'
    },
    {
        text: "lang_AZ_PERSONS_CAPTION_OTHER_IDS_TYPE_ORIGINATOR",
        value: "originator",
        alvqa: 'type-option-originator'
    },
    {
        text: "lang_AZ_PERSONS_CAPTION_OTHER_IDS_TYPE_INHERITOR",
        value: "inheritor",
        alvqa: 'type-option-inheritor'
    },
]
export const DropdownAccountMappingsAlvFields = {
    "import_publishing_income": [{
            text: 'lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE',
            value: 'publishingIncomeWorkTitle',
            alvqa: 'account-mappings-alv-field-work-title'
        },
        {
            text: 'lang_PUBLISHING_CAPTION_COMPOSERS',
            value: 'publishingIncomeComposers',
            alvqa: 'account-mappings-alv-field-composers'
        },
        {
            text: 'lang_PUBLISHING_WORKS_CAPTION_WORK_ID',
            value: 'publishingIncomeWorkId',
            alvqa: 'account-mappings-alv-field-composers'
        },
        {
            text: 'lang_GENERIC_CAPTION_RIGHTS_TYPE',
            value: 'publishingIncomeRightsType',
            alvqa: 'account-mappings-alv-field-rights-type'
        },
        {
            text: 'lang_GENERIC_CAPTION_CATEGORY',
            value: 'publishingIncomeCategory',
            alvqa: 'account-mappings-alv-field-category'
        },
        {
            text: 'lang_GENERIC_AZ_CAPTION_LICENSEE',
            value: 'publishingIncomeLicensee',
            alvqa: 'account-mappings-alv-field-licensee'
        },
        {
            text: 'lang_PUBLISHING_INCOME_CAPTION_INFO',
            value: 'publishingIncomeInfo',
            alvqa: 'account-mappings-alv-field-info'
        },
        {
            text: 'lang_GENERIC_CAPTION_COUNTRY',
            value: 'publishingIncomeCountry',
            alvqa: 'account-mappings-alv-field-country'
        },
        {
            text: 'lang_GENERIC_CAPTION_PERIOD',
            value: 'publishingIncomePeriod',
            alvqa: 'account-mappings-alv-field-period'
        },
        {
            text: 'lang_GENERIC_CAPTION_QUANTITY',
            value: 'publishingIncomeQuantity',
            alvqa: 'account-mappings-alv-field-quantity'
        },
        {
            text: 'lang_GENERIC_CAPTION_COLL_PERCENT',
            value: 'publishingIncomeCollPercent',
            alvqa: 'account-mappings-alv-field-coll-percent'
        },
        {
            text: 'lang_GENERIC_CAPTION_AMOUNT',
            value: 'publishingIncomeAmount',
            alvqa: 'account-mappings-alv-field-amount'
        },
        {
            text: 'lang_GENERIC_CAPTION_RECIPIENT_ID',
            value: 'publishingIncomeRecipientId',
            alvqa: 'account-mappings-alv-field-publishing-recipient-id'
        },
        {
            text: 'lang_GENERIC_CAPTION_SUBCATEGORY',
            value: 'publishingIncomeSubcategory',
            alvqa: 'account-mappings-alv-field-publishing-subcategory'
        },
        {
            text: 'lang_GENERIC_CAPTION_ISWC',
            value: 'publishingIncomeIswc',
            alvqa: 'account-mappings-alv-field-publishing-income-iswc'
        },
        {
            text: 'lang_GENERIC_CAPTION_MEMO',
            value: 'publishingIncomeMemo',
            alvqa: 'account-mappings-alv-field-publishing-income-memo'
        }
    ],
    "import_label_sales_data": [{
            text: 'lang_LABEL_RELEASES_CAPTION_TITLE',
            value: 'labelSalesDataReleaseTitle', // sales_release_name
            alvqa: 'account-mappings-alv-field-label-release-title'
        },
        {
            text: 'lang_GENERIC_CAPTION_EAN',
            value: 'labelSalesDataReleaseEan', // sales_eanupc
            alvqa: 'account-mappings-alv-field-label-release-ean'
        },
        {
            text: 'lang_GENERIC_CAPTION_CATALOGUE_NUMBER',
            value: 'labelSalesDataReleaseCatalogueNumber', // sales_catalog_no
            alvqa: 'account-mappings-alv-field-label-release-catalogue-number'
        },
        {
            text: 'lang_LABEL_TRACKS_CAPTION_ISRC',
            value: 'labelSalesDataTrackIsrc', // sales_isrc
            alvqa: 'account-mappings-alv-field-label-track-isrc'
        },
        {
            text: 'lang_GENERIC_CAPTION_COUNTRY',
            value: 'labelSalesDataCountry', // sales_gebiet
            alvqa: 'account-mappings-alv-field-label-sales-data-country'
        },
        {
            text: 'lang_GENERIC_CAPTION_QUANTITY',
            value: 'labelSalesDataQuantity', // sales_quantity
            alvqa: 'account-mappings-alv-field-label-sales-data-quantity'
        },
        {
            text: 'lang_GENERIC_CAPTION_RETURNS',
            value: 'labelSalesDataReturns', // sales_return
            alvqa: 'account-mappings-alv-field-label-sales-data-returns'
        },
        {
            text: 'lang_GENERIC_CAPTION_RETURNS_VALUE',
            value: 'labelSalesDataReturnsValue', // sales_return_value
            alvqa: 'account-mappings-alv-field-label-sales-data-returns-value'
        },
        {
            text: 'lang_GENERIC_CAPTION_PERIOD',
            value: 'labelSalesDataPeriod', // sales_start_date
            alvqa: 'account-mappings-alv-field-label-sales-data-period'
        },
        {
            text: 'lang_GENERIC_CAPTION_NET',
            value: 'labelSalesDataNet', // sales_type_net
            alvqa: 'account-mappings-alv-field-label-sales-data-net'
        },
        {
            text: 'lang_GENERIC_LABEL_CAPTION_PPD',
            value: 'labelSalesDataPpd', // sales_type_hap
            alvqa: 'account-mappings-alv-field-label-sales-data-ppd'
        },
        {
            text: 'lang_GENERIC_CAPTION_SALES_TYPE',
            value: 'labelSalesDataType', // sales_vk_type
            alvqa: 'account-mappings-alv-field-label-sales-data-type'
        },
        {
            text: 'lang_LABEL_RELEASES_CAPTION_MEDIA_TYPE',
            value: 'labelSalesDataMediaType', // sales_vk_type
            alvqa: 'account-mappings-alv-field-label-sales-media-type'
        },
        {
            text: 'lang_GENERIC_AZ_CAPTION_LICENSEE',
            value: 'labelSalesDataLicensee', // sales_licensee
            alvqa: 'account-mappings-alv-field-label-sales-data-licensee'
        },
        {
            text: 'lang_GENERIC_AZ_CAPTION_SUB_LICENSEE',
            value: 'labelSalesDataSubLicensee', // sales_sub_licensee
            alvqa: 'account-mappings-alv-field-label-sales-data-sublicensee'
        },
        {
            text: 'lang_GENERIC_CAPTION_SUBCATEGORY',
            value: 'labelSalesDataSubCategory', // sales_subcategory
            alvqa: 'account-mappings-alv-field-label-sales-data-subcategory'
        },
        {
            text: 'lang_GENERIC_LABEL_CAPTION_MSP',
            value: 'labelSalesDataMsp',
            alvqa: 'account-mappings-alv-field-label-sales-data-msp'
        }
    ],
    "import_publishing_works": [
        {
            text: 'Work ALVID',
            value: "publishingWorkAlvId"
        },
        {
            text: 'International work title',
            value: "publishingWorkTitle"
        },
        {
            text: "Domestic work title",
            value: "publishingWorkDomesticTitle"
        },
        {
            text: 'Work ISWC',
            value: "publishingWorkIswc"
        },
        {
            text: 'Work performer',
            value: "publishingWorkPerformer"
        },
        {
            text: 'Work duration',
            value: "publishingWorkDuration"
        },
        {
            text: 'Work language',
            value: "publishingWorkLanguage"
        },
        {
            text: 'Work status',
            value: "publishingWorkStatus"
        },
        {
            text: 'Work type',
            value: "publishingWorkType"
        },
        {
            text: 'Work registration date',
            value: "publishingWorkRegistrationDate"
        },
        {
            text: 'Work style',
            value: "publishingWorkGenre"
        },
        {
            text: 'Work catalogue number',
            value: "publishingWorkCatalogueNumber"
        },
        {
            text: 'Work foreign ID',
            value: "publishingWorkForeignWorkIds"
        },
        {
            text: 'Work points',
            value: "publishingWorkPoints"
        },
        {
            text: 'Work notes',
            value: "publishingWorkNotes"
        },
        {
            text: 'Work back collection',
            value: "publishingWorkBackCollection"
        },
        {
            text: 'Work MR split',
            value: "publishingWorkOldMrSplit"
        },
        {
            text: 'Work leading publisher',
            value: "publishingWorkLeadingPublisher"
        },
        {
            text: 'Work society number main',
            value: "publishingWorkSocietyNumberMain"
        },
        {
            text: 'Work society number version',
            value: "publishingWorkSocietyNumberVersion"
        },
        {
            text: 'Work ISRC',
            value: "publishingWorkIsrc"
        },
        {
            text: "Work tags",
            value: "publishingWorkTags"
        },
        {
            text: "Work alternative titles",
            value: "publishingWorkAlternativeTitles"
        },
        {
            text: "Work instrumentation (compiled)",
            value: "publishingWorkInstrumentationShortcut"
        },
        {
            text: "Rolesplit music",
            value: "publishingWorkRolesplitMusic"
        },
        {
            text: "Leading publisher name",
            value: "publishingWorkLeadingPublisherName"
        },
        {
            text: "Score printing",
            value: "publishingWorkScorePrinting"
        }
    ],
    "import_publishing_works_interested_parties": [
        {
            text: 'Interested party name',
            value: "publishingWorkIpName"
        },
        {
            text: 'Interested party A-Z ALVID',
            value: "publishingWorkIpAlvId"
        },
        {
            text: 'Interested party role',
            value: "publishingWorkIpRole"
        },
        {
            text: 'Interested party role order',
            value: "publishingWorkIpRoleOrder"
        },
        {
            text: 'Interested party share type',
            value: "publishingWorkIpShareType"
        },
        {
            text: 'Interested party PWR',
            value: "publishingWorkIpPwrs"
        },
        {
            text: 'Interested party PR%',
            value: "publishingWorkIpPercentPr"
        },
        {
            text: 'Interested party MR%',
            value: "publishingWorkIpPercentMr"
        },
        {
            text: 'Interested party PR society',
            value: "publishingWorkIpSocietyPr"
        },
        {
            text: 'Interested party MR society',
            value: "publishingWorkIpSocietyMr"
        },
        {
            text: 'Interested party PMR',
            value: "publishingWorkIpPmr"
        },
        {
            text: 'Interested party notes',
            value: "publishingWorkIpNotes"
        },
        {
            text: 'Interested party territory',
            value: "publishingWorkIpTerritory"
        },
        {
            text: 'Interested party IPI number',
            value: "publishingWorkIpIpi"
        },
        {
            text: 'Interested party first name',
            value: "publishingWorkIpFirstName"
        },
        {
            text: 'Interested party last name',
            value: "publishingWorkIpLastName"
        },
    ],
    "import_publishing_works_work_ids": [
        {
            text: 'Work ID',
            value: 'publishingWorkId',
        },
        {
            text: 'Source ALVID',
            value: 'publishingWorkIdSourceAlvId'
        },
        {
            text: 'Work ID Country',
            value: 'publishingWorkIdCountry'
        }
    ],
    "import_publishing_works_other_titles": [
        {
            text: 'Other Title',
            value: 'publishingWorkOtherTitle',
        },
        {
            text: 'Title Type',
            value: 'publishingWorkOtherTitleType'
        }
    ],
    "import_publishing_works_instrumentations": [
        {
            text: 'Instrumentation name',
            value: 'workInstrumentationName',
        },
        {
            text: 'Number of instruments',
            value: 'workInstrumentationInstrumentCount'
        },
        {
            text: 'Number of musicians',
            value: 'workInstrumentationMusiciansCount'
        },
        {
            text: 'Number of vocals',
            value: 'workInstrumentationVoicesCount'
        }
    ],
    "import_publishing_works_contracts": [
        {
            text: "Publishing contract ALVID",
            value: "publishingWorkContractAlvid"
        }
    ],
    "import_publishing_projects": [
        {
            text: 'Project ALVID',
            value: 'publishingProjectAlvId'
        },
        {
            text: 'Project Title',
            value: 'publishingProjectTitle'
        },
        {
            text: 'Project Tag',
            value: 'publishingProjectTag'
        },
        {
            text: 'Project Note',
            value: 'publishingProjectNote'
        }
    ],
    "import_publishing_sheets": [
        {
            text: 'Sheet ALVID',
            value: 'publishingSheetAlvId'
        },
        {
            text: 'Sheet Title',
            value: 'publishingSheetTitle'
        },
        {
            text: 'Sheet Number',
            value: 'publishingSheetNumber'
        },
        {
            text: 'First Broadcast Date',
            value: 'publishingSheetFirstBroadcast'
        },
        {
            text: 'Production Year',
            value: 'publishingSheetProductionYear'
        },
        {
            text: 'Sheet Note',
            value: 'publishingSheetNote'
        },
        {
            text: 'Sheet Tags',
            value: 'publishingSheetTag'
        },
        {
            text: 'Sheet Version Type',
            value: 'publishingSheetVersionType'
        },
        {
            text: 'Sheet Regions',
            value: 'publishingSheetRegions'
        },
        {
            text: 'Sheet Project Link',
            value: 'publishingSheetProjectLink'
        },
        {
            text: 'Sheet Type',
            value: 'publishingSheetType'
        },
        {
            text: 'Is commissioned work?',
            value: 'publishingSheetCommissioned'
        },
        {
            text: 'Is cue sheet complete?',
            value: 'publishingSheetCueSheetComplete'
        },
        {
            text: 'TV Station',
            value: 'publishingSheetTvStation'
        },
        {
            text: 'Sync right',
            value: 'publishingSheetSyncRight'
        },
        {
            text: 'Production Country',
            value: 'publishingSheetCountry'
        },
        {
            text: 'AV type',
            value: 'publishingSheetAvType'
        },
        {
            text: 'First exploitation',
            value: 'publishingSheetFirstExploitation'
        },
        {
            text: 'Message type',
            value: 'publishingSheetMessageType'
        },
        {
            text: 'Release type',
            value: 'publishingSheetReleaseType'
        },
        {
            text: 'Producer',
            value: 'publishingSheetProducer'
        },
        {
            text: 'Internet',
            value: 'publishingSheetInternet'
        },
        {
            text: 'Platform',
            value: 'publishingSheetPlatform'
        },
        {
            text: 'Provider',
            value: 'publishingSheetProvider'
        },
        {
            text: 'Website URL',
            value: 'publishingSheetWebsite'
        },
        {
            text: 'Producer Email',
            value: 'publishingSheetProducerEmail'
        },
        {
            text: 'Status',
            value: 'publishingSheetStatus'
        },
        {
            text: 'Set date',
            value: 'publishingSheetSetDate'
        },
        {
            text: 'Set start time (HH:MM)',
            value: 'publishingSheetSetStartTime'
        },
        {
            text: 'Set end time (HH:MM)',
            value: 'publishingSheetSetEndTime'
        },
        {
            text: 'Type of set',
            value: 'publishingSheetSetType'
        },
        {
            text: 'Event name',
            value: 'publishingSheetEventName'
        },
        {
            text: 'Event type',
            value: 'publishingSheetEventType'
        },
        {
            text: 'Type of set',
            value: 'publishingSheetEventVenueAlvId'
        },
        {
            text: 'Venue location',
            value: 'publishingSheetEventVenueSpace'
        },
        {
            text: 'Type of venue',
            value: 'publishingSheetEventVenueType'
        },
        {
            text: 'Event organizer ALVID',
            value: 'publishingSheetEventOrganizerAlvId'
        },
        {
            text: 'Are you organizer?',
            value: 'publishingSheetEventOrganizerYesNo'
        },
        {
            text: 'Bandleader A-Z ALVID',
            value: 'publishingSheetEventBandleaderAlvId'
        },
        {
            text: 'Performer A-Z ALVID',
            value: 'publishingSheetEventPerformerAlvId'
        },
        {
            text: 'Highest ticket price',
            value: 'publishingSheetEventHighestTicketPrice'
        },
        {
            text: 'Number of concertgoers',
            value: 'publishingSheetEventNumberOfConcertgoers'
        },
        {
            text: 'Number of musicians',
            value: 'publishingSheetEventNumberOfMusicians'
        },
    ],
    "import_publishing_sheets_works": [
        {
            text: 'Work ALVID',
            value: 'publishingSheetWorkAlvId'
        },
        {
            text: 'Work GEMA number',
            value: 'publishingSheetWorkGemaNumber'
        },
        {
            text: 'Work seconds',
            value: 'publishingSheetWorkSeconds'
        },
        {
            text: 'Work type',
            value: 'publishingSheetWorkType'
        },
        {
            text: 'Work characteristic',
            value: 'publishingSheetWorkCharacteristic'
        },
        {
            text: 'Work setlist seconds',
            value: 'publishingSheetWorkSetlistSeconds'
        },
        {
            text: 'Work setlist type',
            value: 'publishingSheetWorkSetlistType'
        },
        {
            text: 'Is grand right?',
            value: 'publishingSheetWorkBigRight'
        }
    ],
    "import_label_tracks": [
        {
            text: 'Track ALVID', 
            value: 'labelTrackAlvId'
        },
        {
            text: 'Track title', 
            value: 'labelTrackTitle'
        },
        {
            text:'Track title 2', 
            value: 'labelTrackTitle2'
        },
        {
            text: 'Track title 3', 
            value: 'labelTrackTitle3'
        },
        {
            text: 'Track title 4', 
            value: 'labelTrackTitle4'
        },
        {
            text: 'Track title 5', 
            value: 'labelTrackTitle5'
        },
        {
            text: 'ISRC', 
            value: 'labelTrackIsrc'
        },
        {
            text: 'ISRC 2', 
            value: 'labelTrackIsrc2'
        },
        {
            text: 'ISRC 3', 
            value: 'labelTrackIsrc3'
        },
        {
            text: 'ISRC 4', 
            value: 'labelTrackIsrc4'
        },
        {
            text: 'Other ID', 
            value: 'labelTrackOtherId'
        },
        {
            text: 'Notes', 
            value: 'labelTrackNotes'
        },
        {
            text: 'Duration', 
            value: 'labelTrackDuration'
        },
        {
            text: 'Initial release date', 
            value: 'labelTrackInitialReleaseDate'
        },
        {
            text: 'Rights ownership from',
            value: 'labelTrackRightsOwnershipFrom'
        },
        {
            text: 'Work ALVID', 
            value: 'labelTrackWorkAlvId'
        },
        {
            text: 'Artist ALVID', 
            value: 'labelTrackArtistAlvId'
        },
        {
            text: 'Artist name', 
            value: 'labelTrackArtistName'
        },
        {
            text: 'P Notice', 
            value: 'labelTrackPNotice'
        },
        {
            text: 'Classical work', 
            value: 'labelTrackClassicalWork'
        },
        {
            text: 'Language', 
            value: 'labelTrackLanguage'
        },
        {
            text: 'Recording year', 
            value: 'labelTrackYear'
        },
        {
            text: 'Recording country', 
            value: 'labelTrackCountry'
        },
        {
            text: 'Explicit', 
            value: 'labelTrackExplicit'
        },
        {
            text: 'Live', 
            value: 'labelTrackLive'
        },
        {
            text: 'Instrumental', 
            value: 'labelTrackInstrumental'
        },
        {
            text: "Label ALVID",
            value: 'labelTrackLabelAlvId'
        },
        {
            text: "Disc number",
            value: "labelTrackDiscNumber"
        },
        {
            text: "Track position on disc",
            value: "labelTrackPositionOnDisc"
        },
        {
            text: "Label Contract ALVID",
            value: "labelTrackContractAlvId"
        },
        {
            text: "Track Additional Artists",
            value: "labelTrackAdditionalArtists"
        },
        {
            text: "Track Featured Artists",
            value: "labelTrackFeaturedArtists"
        }
    ],
    "import_label_tracks_other_ids": [
        {
            text: 'Track Other ID',
            value: 'labelTrackSourceId'
        },
        {
            text: 'Track Other ID Source ALVID',
            value: 'labelTrackSourceAlvId'
        }
    ],
    "import_label_releases_other_ids": [
        {
            text: 'Release Other ID',
            value: 'labelReleaseSourceId'
        },
        {
            text: 'Release Other ID Source ALVID',
            value: 'labelReleaseSourceAlvId'
        }
    ],
    "import_label_releases": [
        {
            text: 'Release ALVID',
            value: 'labelReleaseAlvId'
        },
        {
            text: 'Release Title',
            value: 'labelReleaseTitle'
        },
        {
            text: 'Artist ALVID (A-Z)', 
            value: 'labelReleaseArtistAlvId'
        },
        {
            text: 'Artist Name', 
            value: 'labelReleaseArtistName'
        },
        {
            text: 'Physical format', 
            value: 'labelReleasePhysicalFormat'
        },
        {
            text: 'Media Type', 
            value: 'labelReleaseMediaType'
        },
        {
            text: 'Genre 1', 
            value: 'labelReleaseGenre1'
        },
        {
            text: 'Genre 2', 
            value: 'labelReleaseGenre2'
        },
        {
            text: 'Genre 3', 
            value: 'labelReleaseGenre3'
        },
        {
            text: 'Notes', 
            value: 'labelReleaseNotes'
        },
        {
            text: 'Release EAN', 
            value: 'labelReleaseEan'
        },
        {
            text: 'Catalogue number', 
            value: 'labelReleaseCatalogueNo'
        },
        {
            text: 'Other ID', 
            value: 'labelReleaseOtherId'
        },
        {
            text: 'GEMA Catalogue number', 
            value: 'labelReleaseGemaCatalogueNo'
        },
        {
            text: 'GEMA Registration number', 
            value: 'labelReleaseGemaRegistrationNo'
        },
        {
            text: 'GEMA LTN Number', 
            value: 'labelReleaseGemaLtnNo'
        },
        {
            text: 'C Note', 
            value: 'labelReleaseCNote'
        },
        {
            text: 'P Note', 
            value: 'labelReleasePNote'
        },
        {
            text: 'Release tags', 
            value: 'labelReleaseTags'
        },
        {
            text: 'Minimum stock',
            value: 'labelReleaseMinStock'
        },
        {
            text: 'Number of discs',
            value: 'labelReleaseNumberDiscs'
        },
        {
            text: 'Volume',
            value: 'labelReleaseVolume'
        },
        {
            text: 'Weight in grams',
            value: 'labelReleaseWeightGrams'
        },
        {
            text: 'HS Code',
            value: 'labelReleaseHsCode'
        },
        {
            text: 'Retail release date',
            value: 'labelReleaseRetailRelease'
        },
        {
            text: 'Digital release date',
            value: 'labelReleaseDigitalRelease'
        },
        {
            text: 'Pre-release date',
            value: 'labelReleasePreRelease'
        },
        {
            text: 'Conductor',
            value: 'labelReleaseConductor'
        },
        {
            text: 'Musicians',
            value: 'labelReleaseMusicians'
        },
        {
            text: 'Price category',
            value: 'labelReleasePriceCategory'
        },
        {
            text: 'Price list',
            value: 'labelReleasePriceList'
        },
        {
            text: 'Language',
            value: 'labelReleaseLanguage'
        },
        {
            text: 'Compilation tracks',
            value: 'labelReleaseCompTracks'
        },
        {
            text: 'GEMA TAS',
            value: 'labelReleaseGemaTas'
        },
        {
            text: "Label ALVID",
            value: 'labelReleaseLabelAlvId'
        },
        {
            text: "Alternative title",
            value: "labelReleaseAlternativeTitle"
        }
    ],
    "import_az_persons": [
        { 
            text:"ALVID",
            value: "alvId"
        },
        { 
            text:"Company/group name",
            value: "groupName"
        },
        { 
            text:"Department",
            value: "department"
        },
        { 
            text:"Salutation 1",
            value: "salutation"
        },
        { 
            text:"First name",
            value: "firstName"
        },
        { 
            text:"Last name",
            value: "lastName"
        },
        { 
            text:"Address row 1",
            value: "addressRow1"
        },
        {
            text:"Address row 2",
            value: "addressRow2"
        },
        {
            text:"ZIP Code",
            value: "zip"
        },
        {
            text:"City",
            value: "city"
        },
        {
            text:"State",
            value: "state"
        },
        {
            text:"Country",
            value: "country"
        },
        {
            text:"Website",
            value: "web"
        },
        {
            text:"Facebook",
            value: "facebook"
        },
        {
            text:"X (Twitter)",
            value: "twitter"
        },
        {
            text:"Youtube",
            value: "youtube"
        },
        {
            text:"Form of address",
            value: "formOfAddress"
        },
        {
            text:"Salutation 2",
            value: "salutation2"
        },
        {
            text:"Tags",
            value: "tags"
        },
        {
            text:"Phone number",
            value: "phone"
        },
        {
            text:"Private phone number",
            value: "privatePhone"
        },
        {
            text:"Fax",
            value: "fax"
        },
        {
            text:"Mobile phone",
            value: "cellphone"
        },
        {
            text:"Email address",
            value: "email"
        },
        {
            text:"Format of names",
            value: "formatOfNames"
        },
        {
            text:"Notes",
            value: "notes"
        },
        {
            text:"Key name",
            value: "keyName"
        },
        {
            text:"Dealflow",
            value: "dealflow"
        },
        {
            text:"Types",
            value: "type"
        },
        {
            text:"Visibility",
            value: "visibility"
        },
        {
            text:"Labelcode",
            value: "labelcode"
        },
    ],
    "import_az_persons_finance": [
        {
            text: "Payment order",
            value: "paymentOrder"
        },
        {
            text: "Account holder",
            value: "accountHolder"
        },
        {
            text: "Account number",
            value: "accountNumber"
        },
        {
            text: "BIC / SWIFT",
            value: "bic"
        },
        {
            text: "Bank name",
            value: "bankName"
        },
        {
            text: "Tax waiver",
            value: "taxWaiver"
        },
        {
            text: "Publishing statement text",
            value: "publishingStatementText"
        },
        {
            text: "Label statement text",
            value: "labelStatementText"
        },
        {
            text: "Payment target",
            value: "paymentTarget"
        },
        {
            text: "VAT Reatail %",
            value: "retailVat"
        },
        {
            text: "VAT License %",
            value: "licenseVat"
        },
        {
            text: "Company no.",
            value: "companyNo"
        },
        {
            text: "Company registry",
            value: "companyRegistry"
        },
        {
            text: "Tax waiver from date",
            value: "taxWaiverFrom"
        },
        {
            text: "Tax waiver to date",
            value: "taxWaiverTo"
        },
        {
            text: "VAT ID",
            value: "vatId"
        },
        {
            text: "Tax office",
            value: "taxOffice"
        },
        {
            text: "Tax No.",
            value: "taxNo"
        },
        {
            text: "TAX ID",
            value: "taxId"
        },
        {
            text: "Tax Liability %",
            value: "taxLiabilityPercent"
        },
        {
            text: "Withholding tax %",
            value: "taxWithholdingPercent"
        },
    ],
    "import_az_persons_metadata": [
        {
            text: "Language",
            value: "language",
        },
        {
            text: "Birthday",
            value: "birthday",
        },
        {
            text: "Year of death",
            value: "yearOfDeath",
        },
        {
            text: "Customer No.",
            value: "customerNo",
        },
        {
            text: "Currency",
            value: "currency",
        },
        {
            text: "Label company name",
            value: "labelCompanyName",
        },
        {
            text: "GEMA next prefix",
            value: "gemaNextPrefix",
        },
        {
            text: "GEMA next suffix",
            value: "gemaNextSuffix",
        },
        {
            text: "Publishing Statement summary mapping ALVID",
            value: "publishingStatementSummaryAlvid",
        },
        {
            text: "Publishing Statement details mapping ALVID",
            value: "publishingStatementDetailsAlvid",
        },
        {
            text: "Publishing Statement per work mapping ALVID",
            value: "publishingStatementPerWorkAlvid",
        },
        {
            text: "Publishing Statement project mapping ALVID",
            value: "publishingStatementProjectsAlvid",
        },
        {
            text: "Publishing Statement Top 10 Works mapping ALVID",
            value: "publishingStatementTop10Alvid",
        },
        {
            text: "Publishing company name",
            value: "publishingCompanyName",
        },
        {
            text: "BG9 for GEMA",
            value: "bg9ForGema",
        },
        {
            text: "Free author",
            value: "freeAuthor",
        },
        {
            text: "GEMA Member",
            value: "gemaMember",
        },
        {
            text: "Sub-split threshold",
            value: "subSplitThreshold",
        },
    ],
    "import_az_persons_other_ids": [
        {
            text: "ID",
            value: "value"
        },
        {
            text: "Type",
            value: "type"
        },
        {
            text: "Source ALVID",
            value: "sourceAlvid"
        }
    ],
    "import_publishing_broadcast_events": [
        {
            text: "Broadcast date",
            value: "publishingBroadcastDate"
        },
        {
            text: "Start time",
            value: "publishingBroadcastStartTime"
        },
        {
            text: "End time",
            value: "publishingBroadcastEndTime"
        },
        {
            text: "Duration",
            value: "publishingBroadcastDuration"
        },
        {
            text: "Station name",
            value: "publishingBroadcastStationName"
        },
        {
            text: "Station code",
            value: "publishingBroadcastStationCode"
        },
        {
            text: "Series title",
            value: "publishingBroadcastSeriesTitle"
        },
        {
            text: "Episode title",
            value: "publishingBroadcastEpisodeTitle"
        },
        {
            text: "Original title",
            value: "publishingBroadcastOriginalTitle"
        },
        {
            text: "Season / episode",
            value: "publishingBroadcastEpisodeIdentifier"
        },
        {
            text: "Repeat",
            value: "publishingBroadcastIsRepeat"
        },
        {
            text: "Status",
            value: "publishingBroadcastStatus"
        },
        {
            text: "Country",
            value: "publishingBroadcastCountry"
        },
        {
            text: "Time zone",
            value: "publishingBroadcastTimezone"
        },
        {
            text: "External ID",
            value: "publishingBroadcastExternalId"
        }
    ],
    "import_publishing_usage_records": [
        {
            text: "Broadcast date",
            value: "publishingUsageBroadcastDate"
        },
        {
            text: "Start time",
            value: "publishingUsageBroadcastStartTime"
        },
        {
            text: "Station code",
            value: "publishingUsageStationCode"
        },
        {
            text: "Show title",
            value: "publishingUsageShowTitle"
        },
        {
            text: "Season / episode",
            value: "publishingUsageEpisodeIdentifier"
        },
        {
            text: "Production title",
            value: "publishingUsageProductionTitle"
        },
        {
            text: "Production number",
            value: "publishingUsageProductionNumber"
        },
        {
            text: "Production type",
            value: "publishingUsageProductionType"
        },
        {
            text: "Production duration",
            value: "publishingUsageProductionDuration"
        },
        {
            text: "Music duration",
            value: "publishingUsageMusicDuration"
        },
        {
            text: "Work title",
            value: "publishingUsageWorkTitle"
        },
        {
            text: "Work number",
            value: "publishingUsageWorkNumber"
        },
        {
            text: "ISWC",
            value: "publishingUsageIswc"
        },
        {
            text: "Composers",
            value: "publishingUsageComposer"
        },
        {
            text: "Arrangers",
            value: "publishingUsageArranger"
        },
        {
            text: "Broadcast count",
            value: "publishingUsageBroadcastCount"
        },
        {
            text: "Distribution date",
            value: "publishingUsageDistributionDate"
        },
        {
            text: "Category",
            value: "publishingUsageCategory"
        },
        {
            text: "Time zone",
            value: "publishingUsageTimezone"
        }
    ]
}

// Statement types for Company Default Mappings matrix.
// Single source of truth on BE: StatementType.php enum.
// `companyType` is used by the dialog to filter rows for the active company.
export const DropdownCompanyDefaultMappingStatementTypes = [
    {
        text: 'lang_GENERIC_AZ_CAPTION_PUBLISHING_SUMMARY_MAPPING',
        value: 'publishing_statements_summary',
        companyType: 'publishing',
        alvqa: 'company-default-mappings-statement-type-publishing-summary',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_PUBLISHING_DETAILS_MAPPING',
        value: 'publishing_statements_details',
        companyType: 'publishing',
        alvqa: 'company-default-mappings-statement-type-publishing-details',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_PUBLISHING_PER_WORK_MAPPING',
        value: 'publishing_statements_per_work',
        companyType: 'publishing',
        alvqa: 'company-default-mappings-statement-type-publishing-per-work',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_PUBLISHING_PROJECTS_SHEETS_MAPPING',
        value: 'publishing_statements_projects_sheets',
        companyType: 'publishing',
        alvqa: 'company-default-mappings-statement-type-publishing-projects-sheets',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_PUBLISHING_TOP_10_MAPPING',
        value: 'publishing_statements_top10',
        companyType: 'publishing',
        alvqa: 'company-default-mappings-statement-type-publishing-top10',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_PUBLISHING_PAYEE_MAPPING',
        value: 'publishing_statements_payee',
        companyType: 'publishing',
        alvqa: 'company-default-mappings-statement-type-publishing-payee',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_LABEL_DIGITAL_MAPPING',
        value: 'label_statements_digital',
        companyType: 'label',
        alvqa: 'company-default-mappings-statement-type-label-digital',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_LABEL_RETAIL_MAPPING',
        value: 'label_statements_retail',
        companyType: 'label',
        alvqa: 'company-default-mappings-statement-type-label-retail',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_LABEL_LICENSE_MAPPING',
        value: 'label_statements_license',
        companyType: 'label',
        alvqa: 'company-default-mappings-statement-type-label-license',
    },
    {
        text: 'lang_GENERIC_AZ_CAPTION_LABEL_PER_RELEASE_MAPPING',
        fallbackText: 'Statement per release (Label)',
        value: 'label_statements_per_release',
        companyType: 'label',
        alvqa: 'company-default-mappings-statement-type-label-per-release',
    },
]